(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4193],{

/***/ 85496:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(73562);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 73562:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 20570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(4278),
    now = __webpack_require__(74632),
    toNumber = __webpack_require__(12453);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 74632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(11217);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 12453:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(85496),
    isObject = __webpack_require__(4278),
    isSymbol = __webpack_require__(44872);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 74009:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports.NM = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = void 0;

var _handleViewport = _interopRequireDefault(__webpack_require__(89994));

__webpack_unused_export__ = _handleViewport.default;

var _useInViewport = _interopRequireDefault(__webpack_require__(68841));

exports.NM = _useInViewport.default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customProps = ['inViewport', 'enterCount', 'leaveCount'];
__webpack_unused_export__ = customProps;
var _default = _handleViewport.default;
__webpack_unused_export__ = _default;

/***/ }),

/***/ 67270:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.__esModule = true;
exports.noop = exports.defaultProps = exports.defaultOptions = exports.defaultConfig = void 0;
var defaultOptions = {};
exports.defaultOptions = defaultOptions;
var defaultConfig = {
  disconnectOnLeave: false
};
exports.defaultConfig = defaultConfig;

var noop = () => {};

exports.noop = noop;
var defaultProps = {
  onEnterViewport: noop,
  onLeaveViewport: noop
};
exports.defaultProps = defaultProps;

/***/ }),

/***/ 89994:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;

var _react = __webpack_require__(56168);

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(25011));

var _useInViewport = _interopRequireDefault(__webpack_require__(68841));

var _constants = __webpack_require__(67270);

var _jsxRuntime = __webpack_require__(8014);

var _excluded = ["onEnterViewport", "onLeaveViewport"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var isFunctionalComponent = Component => {
  return typeof Component === 'function' && !(Component.prototype && Component.prototype.render);
};

var isReactComponent = Component => {
  return Component.prototype && Component.prototype.isReactComponent;
};

function handleViewport(TargetComponent, options, config) {
  if (options === void 0) {
    options = _constants.defaultOptions;
  }

  if (config === void 0) {
    config = _constants.defaultConfig;
  }

  var ForwardedRefComponent = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
    var refProps = _extends({
      forwardedRef: ref
    }, isReactComponent(TargetComponent) && !isFunctionalComponent(TargetComponent) ? {
      ref
    } : {});

    return /*#__PURE__*/(0, _jsxRuntime.jsx)(TargetComponent, _extends({}, props, refProps));
  });

  function InViewport(_ref) {
    var {
      onEnterViewport = _constants.noop,
      onLeaveViewport = _constants.noop
    } = _ref,
        restProps = _objectWithoutPropertiesLoose(_ref, _excluded);

    var node = (0, _react.useRef)();
    var {
      inViewport,
      enterCount,
      leaveCount
    } = (0, _useInViewport.default)(node, options, config, {
      onEnterViewport,
      onLeaveViewport
    });
    var injectedProps = {
      inViewport,
      enterCount,
      leaveCount
    };
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ForwardedRefComponent, _extends({}, restProps, injectedProps, {
      ref: node
    }));
  }

  var name = TargetComponent.displayName || TargetComponent.name || 'Component';
  InViewport.displayName = "handleViewport(" + name + ")";
  return (0, _hoistNonReactStatics.default)(InViewport, ForwardedRefComponent);
}

var _default = handleViewport;
exports["default"] = _default;

/***/ }),

/***/ 68841:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;

var _react = __webpack_require__(56168);

var _reactDom = __webpack_require__(34323);

var _constants = __webpack_require__(67270);

var useInViewport = function useInViewport(target, options, config, props) {
  if (options === void 0) {
    options = _constants.defaultOptions;
  }

  if (config === void 0) {
    config = _constants.defaultConfig;
  }

  if (props === void 0) {
    props = _constants.defaultProps;
  }

  var {
    onEnterViewport,
    onLeaveViewport
  } = props;
  var [, forceUpdate] = (0, _react.useState)();
  var observer = (0, _react.useRef)();
  var inViewportRef = (0, _react.useRef)(false);
  var intersected = (0, _react.useRef)(false);
  var enterCountRef = (0, _react.useRef)(0);
  var leaveCountRef = (0, _react.useRef)(0);

  function startObserver(_ref) {
    var {
      observerRef
    } = _ref;
    var targetRef = target.current;

    if (targetRef) {
      var node = (0, _reactDom.findDOMNode)(targetRef);

      if (node) {
        observerRef == null ? void 0 : observerRef.observe(node);
      }
    }
  }

  function stopObserver(_ref2) {
    var {
      observerRef
    } = _ref2;
    var targetRef = target.current;

    if (targetRef) {
      var node = (0, _reactDom.findDOMNode)(targetRef);

      if (node) {
        observerRef == null ? void 0 : observerRef.unobserve(node);
      }
    }

    observerRef == null ? void 0 : observerRef.disconnect();
    observer.current = null;
  }

  function handleIntersection(entries) {
    var entry = entries[0] || {};
    var {
      isIntersecting,
      intersectionRatio
    } = entry;
    var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0; // enter

    if (!intersected.current && isInViewport) {
      intersected.current = true;
      onEnterViewport == null ? void 0 : onEnterViewport();
      enterCountRef.current += 1;
      inViewportRef.current = isInViewport;
      forceUpdate(isInViewport);
      return;
    } // leave


    if (intersected.current && !isInViewport) {
      intersected.current = false;
      onLeaveViewport == null ? void 0 : onLeaveViewport();

      if (config.disconnectOnLeave && observer.current) {
        // disconnect obsever on leave
        observer.current.disconnect();
      }

      leaveCountRef.current += 1;
      inViewportRef.current = isInViewport;
      forceUpdate(isInViewport);
    }
  }

  function initIntersectionObserver(_ref3) {
    var {
      observerRef
    } = _ref3;

    if (!observerRef) {
      observer.current = new IntersectionObserver(handleIntersection, options);
      return observer.current;
    }

    return observerRef;
  }

  (0, _react.useEffect)(() => {
    var observerRef = observer.current; // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API

    observerRef = initIntersectionObserver({
      observerRef
    });
    startObserver({
      observerRef
    });
    return () => {
      stopObserver({
        observerRef
      });
    };
  }, [target.current, options, config, onEnterViewport, onLeaveViewport]);
  return {
    inViewport: inViewportRef.current,
    enterCount: enterCountRef.current,
    leaveCount: leaveCountRef.current
  };
};

var _default = useInViewport;
exports["default"] = _default;

/***/ }),

/***/ 70008:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vagas",
      function () {
        return __webpack_require__(75616);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1723:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/PurpleFaBriefcase.fc200619.svg","height":24,"width":25});

/***/ }),

/***/ 82161:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/PurpleFaDollarSign.8c7fcd0b.svg","height":24,"width":25});

/***/ }),

/***/ 90748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ Badge; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(34237);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(53857);
;// CONCATENATED MODULE: ./src/components/atoms/badge/variants/remote.tsx
var remote = {
    backgroundColor: 'purple.200',
    color: 'primary.500',
    textTransform: 'capitalize'
};

;// CONCATENATED MODULE: ./src/components/atoms/badge/variants/rawText.tsx
var rawText = {
    backgroundColor: 'purple.200',
    color: 'primary.500',
    textTransform: 'none'
};

;// CONCATENATED MODULE: ./src/components/atoms/badge/variants/index.tsx


var variants = {
    remote: remote,
    rawText: rawText
};

;// CONCATENATED MODULE: ./src/components/atoms/badge/index.tsx




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Badge = function(_param) /*#__PURE__*/ {
    var _variant = _param.variant, variant = _variant === void 0 ? 'remote' : _variant, text = _param.text, _isClosable = _param.isClosable, isClosable = _isClosable === void 0 ? false : _isClosable, onClose = _param.onClose, props = _objectWithoutProperties(_param, [
        "variant",
        "text",
        "isClosable",
        "onClose"
    ]);
    return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Badge */.Ct, _objectSpread({
        fontWeight: 600,
        borderRadius: "base",
        fontSize: "xs",
        letterSpacing: "thight",
        px: 2,
        py: 1
    }, variants[variant], props, {
        display: "flex",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                children: text
            }),
            isClosable && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                _hover: {
                    textColor: 'black',
                    bgColor: '#00000010'
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineClose */.oHP, {
                    onClick: function(e) {
                        return onClose && onClose(e);
                    }
                })
            })
        ]
    }));
};



/***/ }),

/***/ 70579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ BadgeTech; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47386);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34237);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var BadgeTech = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function(_param, ref) {
    var text = _param.text, textColor = _param.textColor, borderColor = _param.borderColor, hoverBgColor = _param.hoverBgColor, hoverTextColor = _param.hoverTextColor, props = _objectWithoutProperties(_param, [
        "text",
        "textColor",
        "borderColor",
        "hoverBgColor",
        "hoverTextColor"
    ]);
    var hoverBgColorToken = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useToken */ .dQ)('colors', hoverBgColor);
    var hoverTextColorToken = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useToken */ .dQ)('colors', hoverTextColor);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, _objectSpread({
        ref: ref,
        fontWeight: 700,
        textTransform: "uppercase",
        borderColor: borderColor,
        borderRadius: 6,
        borderStyle: "solid",
        borderWidth: 2.5,
        color: textColor,
        fontSize: "xs",
        letterSpacing: "widest",
        px: 2.5,
        py: 1,
        _hover: {
            bgColor: hoverBgColorToken,
            color: hoverTextColorToken
        }
    }, props, {
        children: text
    })));
});

BadgeTech.displayName = 'BadgeTech';


/***/ }),

/***/ 44085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ FlagEnum; },
/* harmony export */   "A": function() { return /* binding */ CountryFlag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80241);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62044);
/* harmony import */ var lib_constants_translateNamespaces__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8366);




var FlagEnum;
(function(FlagEnum) {
    FlagEnum["en"] = 'en';
    FlagEnum["br"] = 'pt_BR';
    FlagEnum["usFlag"] = 'us_flag';
    FlagEnum["brFlag"] = 'br_flag';
})(FlagEnum || (FlagEnum = {}));
var CountryFlag = function(param) {
    var flag = param.flag, _height = param.height, height = _height === void 0 ? 25 : _height;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(lib_constants_translateNamespaces__WEBPACK_IMPORTED_MODULE_3__/* .TRANSLATE_NAMESPACES.global */ .V.global).t;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        style: {
            position: 'relative',
            display: 'inline-block',
            height: "".concat(height, "px"),
            width: "".concat(height, "px")
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
            src: "/flags/".concat(flag, ".png"),
            layout: "fill",
            alt: t("flag.".concat(flag))
        })
    }));
};


/***/ }),

/***/ 68590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34237);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var fontSizes = {
    h4: [
        '14px',
        '14px',
        '16px',
        '16px'
    ],
    h3: [
        '16px',
        '16px',
        '20px',
        '20px'
    ],
    h2: [
        '28px',
        '28px',
        '28px',
        '28px'
    ],
    h1: [
        '36px',
        '36px',
        '36px',
        '36px'
    ]
};
var boostFontSizes = {
    h4: [
        '28px',
        '28px',
        '28px',
        '28px'
    ],
    h3: [
        '40px',
        '40px',
        '48px',
        '48px'
    ],
    h2: [
        '48px',
        '48px',
        '60px',
        '60px'
    ],
    h1: [
        '60px',
        '60px',
        '68px',
        '68px'
    ]
};
var fontWeights = {
    h4: '500',
    h3: '500',
    h2: '600',
    h1: '600'
};
var Heading = function(_param) /*#__PURE__*/ {
    var children = _param.children, _format = _param.format, format = _format === void 0 ? 'h1' : _format, _boostSizeLength = _param.boostSizeLength, boostSizeLength = _boostSizeLength === void 0 ? 0 : _boostSizeLength, _pt = _param.pt, pt = _pt === void 0 ? 2 : _pt, _mt = _param.mt, mt = _mt === void 0 ? 2 : _mt, props = _objectWithoutProperties(_param, [
        "children",
        "format",
        "boostSizeLength",
        "pt",
        "mt"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, _objectSpread({
        as: format,
        fontSize: boostSizeLength ? boostFontSizes[format] : fontSizes[format] || fontSizes.h1,
        fontWeight: fontWeights[format] || fontWeights.h1,
        letterSpacing: "1px",
        color: "text.100",
        lineHeight: "normal",
        "data-testid": "heading",
        pt: pt,
        mt: mt
    }, props, {
        children: boostSizeLength && children ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                children.slice(0, boostSizeLength),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                    display: "inline",
                    fontSize: fontSizes[format] || fontSizes.h1,
                    children: children.slice(boostSizeLength)
                })
            ]
        }) : children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 95307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ MobileTooltip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27446);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47386);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34237);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25215);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45666);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var MobileTooltip = function(_param) {
    var children = _param.children, _showBackground = _param.showBackground, showBackground = _showBackground === void 0 ? true : _showBackground, props = _objectWithoutProperties(_param, [
        "children",
        "showBackground"
    ]);
    var ref = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useDisclosure */ .qY)(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    var grey900 = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .useToken */ .dQ)('colors', 'grey.900');
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, _objectSpread({}, props, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaInfoCircle */ .DAO, {
                    cursor: "pointer",
                    color: grey900,
                    onClick: function(event) {
                        event.stopPropagation();
                        onOpen();
                    }
                })
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Drawer */ .dy, {
                placement: "bottom",
                onClose: onClose,
                isOpen: isOpen,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .DrawerOverlay */ .P1, {
                        background: showBackground ? 'blackAlpha.600' : 'none'
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .DrawerContent */ .sc, {
                        backgroundColor: "primary.500",
                        p: 2.5,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, {
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                children,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .DrawerCloseButton */ .cC, {
                                    color: "white.100",
                                    position: "static"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};



/***/ }),

/***/ 9123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ SalaryRange; },
  "l": function() { return /* binding */ SalarySuffixTypes; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(34237);
;// CONCATENATED MODULE: ./src/lib/utils/formatSalaryWithoutCurrency/index.ts
/**
 * Formats salary without currency and with decimals.
 * Example: 9.837,00
 *
 * @param salary {number | undefined}
 * @param decimals {number}
 *
 * @returns {string}
 */ var formatSalaryWithoutCurrency = function(salary) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var format = {
        minimumFractionDigits: decimals,
        currency: 'BRL'
    };
    if (!salary && salary !== 0) return '';
    return salary.toLocaleString('pt-BR', format);
};

;// CONCATENATED MODULE: ./src/components/atoms/salaryRange/index.tsx



var SalarySuffixTypes;
(function(SalarySuffixTypes) {
    SalarySuffixTypes["CLT"] = ' BRL/m\xeas';
    SalarySuffixTypes["PJ"] = ' BRL/m\xeas';
    SalarySuffixTypes["PJ_US"] = ' USD/ano';
    SalarySuffixTypes["None"] = '';
})(SalarySuffixTypes || (SalarySuffixTypes = {}));
var SalaryRange = function(param) {
    var minSalary = param.minSalary, maxSalary = param.maxSalary, currency = param.currency, suffix = param.suffix, _isFilter = param.isFilter, isFilter = _isFilter === void 0 ? false : _isFilter;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                mr: 1,
                color: "text.700",
                children: currency
            }),
            formatSalaryWithoutCurrency(minSalary, 0),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                mx: 1,
                color: isFilter ? 'primary.500' : undefined,
                children: "-"
            }),
            isFilter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                mr: 1,
                color: "text.700",
                children: currency
            }) : null,
            formatSalaryWithoutCurrency(maxSalary, 0),
            suffix ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                ml: 1,
                color: "text.700",
                children: suffix
            }) : null
        ]
    });
};


/***/ }),

/***/ 68335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ SanitizeHTML; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34237);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78552);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_2__);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var defaultOptions = {
    allowedTags: [
        'b',
        'i',
        'em',
        'strong',
        'a',
        'br',
        'p',
        'ul',
        'li'
    ],
    transformTags: {
        ul: 'ol'
    },
    allowedAttributes: {
        a: [
            'href'
        ]
    }
};
var SanitizeHTML = function(_param) /*#__PURE__*/ {
    var _html = _param.html, html = _html === void 0 ? '' : _html, options = _param.options, props = _objectWithoutProperties(_param, [
        "html",
        "options"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, _objectSpread({}, props, {
        dangerouslySetInnerHTML: {
            __html: sanitize_html__WEBPACK_IMPORTED_MODULE_2___default()(html, _objectSpread({}, defaultOptions, options))
        }
    }));
};



/***/ }),

/***/ 32112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ TextTag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34237);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var TextTag = function(_param) {
    var text = _param.text, backgroundColor = _param.backgroundColor, _textColor = _param.textColor, textColor = _textColor === void 0 ? 'primary.50' : _textColor, icon = _param.icon, minH = _param.minH, props = _objectWithoutProperties(_param, [
        "text",
        "backgroundColor",
        "textColor",
        "icon",
        "minH"
    ]);
    var heightProps = minH ? {
        minH: minH
    } : {
        h: '20px'
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, _objectSpread({
        alignItems: "center",
        mr: 2,
        bg: backgroundColor,
        p: 1,
        borderRadius: 4,
        textColor: textColor,
        fontSize: "xs",
        "data-testid": "text-tag-container"
    }, heightProps, props, {
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                mr: 1,
                children: icon
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                "data-testid": "text-tag-text",
                children: text
            })
        ]
    })));
};



/***/ }),

/***/ 41758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ AsyncSelectFocus; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/chakra-ui-hooks.esm.js
var chakra_ui_hooks_esm = __webpack_require__(27446);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(34237);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/accordion/dist/chakra-ui-accordion.esm.js
var chakra_ui_accordion_esm = __webpack_require__(37816);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./src/components/atoms/badge/index.tsx + 3 modules
var badge = __webpack_require__(90748);
// EXTERNAL MODULE: ./src/components/atoms/form/fieldTitle/index.tsx + 6 modules
var fieldTitle = __webpack_require__(52527);
// EXTERNAL MODULE: ./src/lib/generated/graphql/index.tsx
var graphql = __webpack_require__(16402);
// EXTERNAL MODULE: ./src/lib/repositories/jobsShowcaseFilters/index.ts
var jobsShowcaseFilters = __webpack_require__(47953);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/chakra-ui-input.esm.js
var chakra_ui_input_esm = __webpack_require__(29237);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js
var chakra_ui_button_esm = __webpack_require__(65618);
;// CONCATENATED MODULE: ./src/components/molecules/jobs/filters/asyncSelectFocus/focusItem.tsx




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var FocusItems = function(param) {
    var suggestFocus = param.suggestFocus, allFocuses = param.allFocuses, selectedItems = param.selectedItems, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? 'Digite para pesquisar' : _placeholder, notifyChange = param.notifyChange;
    var ref3 = (0,react.useState)(''), searchText = ref3[0], setSearchText = ref3[1];
    var ref1 = (0,react.useState)([]), filteredData = ref1[0], setFilteredData = ref1[1];
    var ref2 = (0,jobsShowcaseFilters/* useJobFilters */.VP)(), filters = ref2.filters, setFocuses = ref2.setFocuses;
    var loadFromSuggestions = function(excludeIds) {
        setFilteredData(suggestFocus === null || suggestFocus === void 0 ? void 0 : suggestFocus.filter(function(focus) {
            return !(excludeIds === null || excludeIds === void 0 ? void 0 : excludeIds.includes(focus.id));
        }));
    };
    var loadFromFocus = function(excludeIds) {
        var parsedData = allFocuses.filter(function(focus) {
            return focus.description.toLowerCase().includes(searchText) && !(excludeIds === null || excludeIds === void 0 ? void 0 : excludeIds.includes(focus.id));
        });
        setFilteredData(parsedData);
    };
    var handleItemsChange = function() {
        var ref;
        var excludeIds = notifyChange ? (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.map(function(focus) {
            return focus.value;
        })) || [] : (filters === null || filters === void 0 ? void 0 : (ref = filters.focuses) === null || ref === void 0 ? void 0 : ref.map(function(focus) {
            return focus.id;
        })) || [];
        if (!searchText && suggestFocus) {
            loadFromSuggestions(excludeIds);
        } else {
            loadFromFocus(excludeIds);
        }
    };
    var onChange = function(focus) {
        if (notifyChange) {
            notifyChange(focus);
        } else {
            var parsedFilters = [];
            if (filters.focuses && filters.focuses.includes(focus)) {
                parsedFilters = filters.focuses.filter(function(f) {
                    return f.id !== focus.id;
                });
            } else {
                var _focuses;
                parsedFilters = _toConsumableArray((_focuses = filters.focuses) !== null && _focuses !== void 0 ? _focuses : []).concat([
                    focus
                ]);
            }
            setFocuses(parsedFilters);
        }
    };
    (0,react.useEffect)(function() {
        handleItemsChange();
    }, [
        searchText,
        filters,
        selectedItems
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_input_esm/* InputGroup */.BZ, {
                flexDirection: "column",
                marginTop: -2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_input_esm/* Input */.II, {
                        "data-testid": "input",
                        "aria-label": "Pesquisar",
                        placeholder: placeholder,
                        height: 10,
                        width: "100%",
                        type: "text",
                        name: "focusSearch",
                        onChange: function(e) {
                            return setSearchText(e.currentTarget.value);
                        },
                        value: searchText,
                        border: 0,
                        fontWeight: "400",
                        fontSize: "14px",
                        _focus: {
                            outline: 'none'
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            paddingLeft: 5,
                            paddingRight: 5,
                            marginBottom: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
                    })
                ]
            }),
            (filteredData === null || filteredData === void 0 ? void 0 : filteredData.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                alignItems: "center",
                justifyContent: "center",
                color: "text.200",
                children: [
                    "Nenhum resultado encontrado",
                    ' '
                ]
            }) : filteredData.map(function(focus) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_accordion_esm/* AccordionItem */.Qd, {
                    border: "none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                        "data-testid": "asyncSelectFocus-".concat(focus.id),
                        width: "100%",
                        sx: {
                            backgroundColor: 'white'
                        },
                        px: 2,
                        fontSize: "sm",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "normal",
                        _hover: {
                            bgColor: 'primary.150'
                        },
                        _focus: {
                            boxShadow: 'none'
                        },
                        onClick: function() {
                            return onChange(focus);
                        },
                        children: focus.description
                    }, focus.id)
                }, focus.id);
            })
        ]
    }));
};
/* harmony default export */ var focusItem = (FocusItems);

;// CONCATENATED MODULE: ./src/components/molecules/jobs/filters/asyncSelectFocus/index.tsx








function asyncSelectFocus_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function asyncSelectFocus_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return asyncSelectFocus_arrayLikeToArray(arr);
}
function asyncSelectFocus_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function asyncSelectFocus_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function asyncSelectFocus_toConsumableArray(arr) {
    return asyncSelectFocus_arrayWithoutHoles(arr) || asyncSelectFocus_iterableToArray(arr) || asyncSelectFocus_unsupportedIterableToArray(arr) || asyncSelectFocus_nonIterableSpread();
}
function asyncSelectFocus_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return asyncSelectFocus_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return asyncSelectFocus_arrayLikeToArray(o, minLen);
}
var MAX_WIDTH = 400;
var AsyncSelectFocus = function(param1) {
    var expands = param1.expands, _label = param1.label, label = _label === void 0 ? 'Foco de Carreira' : _label, subTitle = param1.subTitle, selectedCareer = param1.selectedCareer, onChange = param1.onChange, ref6 = param1.ref, isRequired = param1.isRequired, isFull = param1.isFull, selectedItems = param1.selectedItems, placeholder = param1.placeholder, _onlyActiveJobs = param1.onlyActiveJobs, onlyActiveJobs = _onlyActiveJobs === void 0 ? false : _onlyActiveJobs;
    var ref1 = (0,react.useState)(MAX_WIDTH), pannelWidth = ref1[0], setPannelWidth = ref1[1];
    var ref2 = (0,react.useState)([]), accordionIndex = ref2[0], setAccordionIndex = ref2[1];
    var accordionRef = (0,react.useRef)(null);
    var ref3 = (0,jobsShowcaseFilters/* useJobFilters */.VP)(), filters = ref3.filters, setFocuses = ref3.setFocuses;
    var ref4 = (0,graphql/* useGetActiveFocusesQuery */.wss)({
        fetchPolicy: 'cache-first',
        variables: {
            availableForCandidates: true,
            careerSlugs: selectedCareer && [
                selectedCareer
            ] || undefined
        }
    }), allFocuses = ref4.data, isLoadingFocuses = ref4.loading;
    var ref5 = (0,graphql/* useGetFocusSuggestionsQuery */.HUP)({
        fetchPolicy: 'cache-first',
        variables: {
            careerSlug: selectedCareer,
            onlyActiveJobs: onlyActiveJobs
        }
    }), suggestFocus = ref5.data, isLoadingSuggestions = ref5.loading;
    (0,chakra_ui_hooks_esm/* useOutsideClick */.O3)({
        ref: accordionRef,
        handler: function() {
            if (accordionIndex.length > 0) setAccordionIndex([]);
        }
    });
    (0,react.useEffect)(function() {
        var listener = function() {
            var w = window.document.documentElement.clientWidth;
            var percentage = 0.25;
            var maxW = MAX_WIDTH;
            setPannelWidth(w * percentage >= maxW ? maxW : w * percentage);
        };
        window.addEventListener('resize', listener);
        return function() {
            return window.removeEventListener('resize', listener);
        };
    }, []);
    var handleUpdate = function(focus) {
        if (onChange) {
            onChange(focus);
        }
    };
    var data = onChange ? selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.map(function(item) {
        return {
            id: item.value,
            description: item.label,
            career: item.career
        };
    }) : filters.focuses;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
        w: "full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldTitle/* FieldTitle */.m, {
                mb: 1,
                label: label,
                fontSize: 14,
                fontWeight: 700,
                color: "text.900",
                ref: ref6,
                isRequired: isRequired
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_accordion_esm/* Accordion */.UQ, {
                index: accordionIndex,
                reduceMotion: !expands,
                width: "full",
                py: 1,
                color: "text.300",
                allowMultiple: true,
                border: "none",
                boxShadow: "none",
                ref: accordionRef,
                onChange: function(e) {
                    return setAccordionIndex(asyncSelectFocus_toConsumableArray(e));
                },
                dataTest: "asyncSelectFocus",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_accordion_esm/* AccordionItem */.Qd, {
                    isDisabled: isLoadingFocuses || isLoadingSuggestions,
                    border: "none",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_accordion_esm/* AccordionButton */.KF, {
                            "data-testid": "asyncSelectFocus-button",
                            fontSize: "sm",
                            fontWeight: 700,
                            border: "1px solid lightgray",
                            borderRadius: 2,
                            _focus: {
                                boxShadow: 'none',
                                outline: 'none'
                            },
                            _hover: {
                                bgColor: 'background.50'
                            },
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            py: 0,
                            minH: 10,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                                    justify: "start",
                                    wrap: "wrap",
                                    w: "93%",
                                    minH: 9,
                                    borderRight: "1px solid lightgrey",
                                    children: data && data.length > 0 ? data.map(function(focus) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(badge/* Badge */.C, {
                                            mt: 1,
                                            mr: 1,
                                            mb: 1,
                                            text: focus.description,
                                            isClosable: true,
                                            onClose: function(e) {
                                                var ref;
                                                e.preventDefault();
                                                if (onChange) {
                                                    onChange(focus);
                                                }
                                                setFocuses((ref = filters.focuses) === null || ref === void 0 ? void 0 : ref.filter(function(param) {
                                                    var id = param.id;
                                                    return id !== focus.id;
                                                }));
                                            }
                                        }, focus.id);
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                        color: "text.200",
                                        fontWeight: 600,
                                        mt: 2,
                                        children: "Selecione um ou mais focos"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                                    justify: "center",
                                    alignItems: "center",
                                    w: 21,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_accordion_esm/* AccordionIcon */.XE, {
                                        fontSize: "xl",
                                        color: "primary.500",
                                        mr: -4
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_accordion_esm/* AccordionPanel */.Hk, {
                            maxW: expands ? 'full' : pannelWidth,
                            maxH: expands ? 500 : 350,
                            w: "100%",
                            overflow: "scroll",
                            overflowX: "hidden",
                            mt: 2,
                            borderRadius: 4,
                            border: "1px solid lightgray",
                            position: expands ? 'relative' : 'absolute',
                            zIndex: "popover",
                            backgroundColor: "white",
                            pb: 4,
                            px: 0,
                            children: [
                                isFull && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "text.200",
                                    children: [
                                        "N\xe3o \xe9 poss\xedvel selecionar mais que 3 \xe1reas",
                                        ' '
                                    ]
                                }),
                                !isFull && suggestFocus && allFocuses && /*#__PURE__*/ (0,jsx_runtime.jsx)(focusItem, {
                                    suggestFocus: !onChange || (suggestFocus === null || suggestFocus === void 0 ? void 0 : suggestFocus.getFocusSuggestions.focus.length) > 10 ? suggestFocus === null || suggestFocus === void 0 ? void 0 : suggestFocus.getFocusSuggestions.focus : undefined,
                                    allFocuses: allFocuses.getActiveFocuses,
                                    selectedItems: selectedItems,
                                    placeholder: placeholder,
                                    notifyChange: onChange && handleUpdate
                                })
                            ]
                        }),
                        subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            color: "text.200",
                            fontSize: "0.9rem",
                            fontStyle: "italic",
                            mt: 1,
                            children: subTitle
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ }),

/***/ 96333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ UnauthenticatedShowInterestButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75657);
/* harmony import */ var lib_constants_paths__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29770);
/* harmony import */ var components_atoms_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65186);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var UnauthenticatedShowInterestButton = function(_param) {
    var props = _extends({}, _param);
    var text = 'Acessar perfil para demonstrar interesse!';
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
        href: lib_constants_paths__WEBPACK_IMPORTED_MODULE_3__/* .CANDIDATE_SIGN_IN */ .rb,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
            "aria-label": text
        }, props, {
            children: text
        }))
    }));
};



/***/ }),

/***/ 13346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nd": function() { return /* binding */ jobExperienceLevelMap; },
/* harmony export */   "sC": function() { return /* binding */ jobExperienceLevelOptions; },
/* harmony export */   "st": function() { return /* binding */ experienceDescription; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var JobExperienceLevelEnum = {
    ASSISTANCE: {
        seniority: 'Assistente',
        description: ''
    },
    INTERNSHIP: {
        seniority: 'Est\xe1gio',
        description: ''
    },
    ENTRY_LEVEL: {
        seniority: 'J\xfanior',
        description: ''
    },
    MID_LEVEL: {
        seniority: 'Pleno',
        description: ''
    },
    SENIOR_LEVEL: {
        seniority: 'S\xeanior',
        description: ''
    },
    DIRECTOR: {
        seniority: 'Diretor',
        description: ''
    },
    EXECUTIVE: {
        seniority: 'Executivo',
        description: ''
    }
};
var jobExperienceLevelMap = _objectSpread({}, JobExperienceLevelEnum);
var jobExperienceLevelOptions = Object.keys(JobExperienceLevelEnum).map(function(key) {
    return {
        value: key,
        label: jobExperienceLevelMap[key].seniority
    };
});
var experienceDescription = function(years, title, type) {
    if (!title || years === undefined) return '';
    var suffix = type === 'focus' ? 'como' : 'em';
    var phrase = years === 0 ? "Sem experi\xeancia necess\xe1ria ".concat(suffix, " ") : "".concat(years, "+ anos ").concat(suffix, " ");
    return "".concat(phrase, " ").concat(title);
};


/***/ }),

/***/ 19713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15579);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75332);
/* harmony import */ var lib_constants_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70333);
/* harmony import */ var lib_constants_paths__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29770);
/* harmony import */ var lib_constants_cookies__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12062);






function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
/**
 * Hook that exposes functions to handle user sessions.
 */ var useSession = function() {
    var ref = _slicedToArray((0,react_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), 3), cookies = ref[0], setCookie = ref[1], removeCookie = ref[2];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''), currentToken = ref1[0], setCurrentToken = ref1[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var authTokenCookie = cookies[lib_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .AUTH_TOKEN */ .UA];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setCurrentToken(authTokenCookie);
    }, [
        authTokenCookie
    ]);
    var createSession = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(token, userType) {
        var redirectTo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : lib_constants_paths__WEBPACK_IMPORTED_MODULE_4__/* .ROOT */ .Dx;
        setCookie(lib_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .AUTH_TOKEN */ .UA, token, {
            path: lib_constants_paths__WEBPACK_IMPORTED_MODULE_4__/* .ROOT */ .Dx
        });
        setCookie(lib_constants_cookies__WEBPACK_IMPORTED_MODULE_5__/* .USER_TYPE */ .$A, userType, {
            path: lib_constants_paths__WEBPACK_IMPORTED_MODULE_4__/* .ROOT */ .Dx
        });
        router.push(redirectTo);
    }, [
        setCookie,
        router
    ]);
    var endSession = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        removeCookie(lib_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .AUTH_TOKEN */ .UA, {
            path: '/'
        });
        removeCookie(lib_constants_cookies__WEBPACK_IMPORTED_MODULE_5__/* .USER_TYPE */ .$A, {
            path: '/'
        });
        removeCookie(lib_constants_cookies__WEBPACK_IMPORTED_MODULE_5__/* .NEXT_LOCALE */ .Ky, {
            path: '/'
        });
        window.location.href = lib_constants_paths__WEBPACK_IMPORTED_MODULE_4__/* .LOGOUT */ .Nv;
    }, [
        removeCookie
    ]);
    var payload = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            createSession: createSession,
            endSession: endSession,
            currentToken: currentToken
        };
    }, [
        currentToken,
        createSession,
        endSession
    ]);
    return payload;
};
/* harmony default export */ __webpack_exports__["Z"] = (useSession);


/***/ }),

/***/ 97635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E1": function() { return /* binding */ $candidate; },
/* harmony export */   "Aw": function() { return /* binding */ setCandidate; },
/* harmony export */   "Vd": function() { return /* binding */ updateCandidateProfile; }
/* harmony export */ });
/* harmony import */ var _ngneat_elf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34127);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
/**
 * Create store and persist state in local storage
 */ var ref = (0,_ngneat_elf__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)((0,_ngneat_elf__WEBPACK_IMPORTED_MODULE_0__/* .withProps */ .vl)({
    candidate: undefined
})), state = ref.state, config = ref.config;
var CandidateStore = new _ngneat_elf__WEBPACK_IMPORTED_MODULE_0__/* .Store */ .yh({
    name: 'CandidateStore',
    state: state,
    config: config
});
/**
 * Export data
 */ var $candidate = CandidateStore.pipe((0,_ngneat_elf__WEBPACK_IMPORTED_MODULE_0__/* .select */ .Ys)(function(s) {
    return s.candidate;
}));
function setCandidate(candidate) {
    CandidateStore.update(function(s) {
        return _objectSpread({}, s, {
            candidate: candidate
        });
    });
}
function updateCandidateProfile(fieldsToUpdate) {
    CandidateStore.update(function(s) {
        var candidate = _objectSpread({}, s.candidate, fieldsToUpdate);
        return _objectSpread({}, s, {
            candidate: candidate
        });
    });
}


/***/ }),

/***/ 47953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PW": function() { return /* binding */ DEFAULT_VALUE; },
/* harmony export */   "VP": function() { return /* binding */ useJobFilters; }
/* harmony export */ });
/* unused harmony exports $filters, setFilters, setCompanyLocation, setFocuses, setCity, setMaxSalary, setMinSalary, setOrder, setWorkMode, setSeniority, setTechs, setType, setPage */
/* harmony import */ var _ngneat_elf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34127);
/* harmony import */ var _ngneat_elf_persist_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97121);
/* harmony import */ var _ngneat_react_rxjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78596);
/* harmony import */ var lib_generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16402);




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var DEFAULT_VALUE = {
    companyLocation: [],
    order: lib_generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .OrderEnum.Newer */ .lzH.Newer,
    page: 1,
    focuses: [],
    seniority: [],
    workMode: [],
    type: []
};
var jobsShowcaseFiltersStore = (0,_ngneat_elf__WEBPACK_IMPORTED_MODULE_2__/* .createStore */ .MT)({
    name: 'jobs_showcase_filters'
}, (0,_ngneat_elf__WEBPACK_IMPORTED_MODULE_2__/* .withProps */ .vl)(DEFAULT_VALUE));
(0,_ngneat_elf_persist_state__WEBPACK_IMPORTED_MODULE_3__/* .persistState */ .xi)(jobsShowcaseFiltersStore, {
    key: 'jobs_showcase_filters',
    storage: _ngneat_elf_persist_state__WEBPACK_IMPORTED_MODULE_3__/* .sessionStorageStrategy */ .o3
});
var $filters = jobsShowcaseFiltersStore.pipe((0,_ngneat_elf__WEBPACK_IMPORTED_MODULE_2__/* .select */ .Ys)(function(state) {
    return state;
}));
var setFilters = function(filters) {
    return jobsShowcaseFiltersStore.update(function() {
        return filters;
    });
};
var setCompanyLocation = function(companyLocation) {
    return jobsShowcaseFiltersStore.update(function(state) {
        return _objectSpread({}, state, {
            companyLocation: companyLocation,
            page: DEFAULT_VALUE.page
        });
    });
};
var setFocuses = function(focuses) {
    return jobsShowcaseFiltersStore.update(function(state) {
        return _objectSpread({}, state, {
            focuses: focuses,
            page: DEFAULT_VALUE.page
        });
    });
};
var setCity = function(city) {
    return jobsShowcaseFiltersStore.update(function(state) {
        return _objectSpread({}, state, {
            city: city,
            page: DEFAULT_VALUE.page
        });
    });
};
var setMaxSalary = function(maxSalary) {
    return jobsShowcaseFiltersStore.update(function(state) {
        return _objectSpread({}, state, {
            maxSalary: maxSalary,
            page: DEFAULT_VALUE.page
        });
    });
};
var setMinSalary = function(minSalary) {
    return jobsShowcaseFiltersStore.update(function(state) {
        return _objectSpread({}, state, {
            minSalary: minSalary,
            page: DEFAULT_VALUE.page
        });
    });
};
var setOrder = function(order) {
    return jobsShowcaseFiltersStore.update(function(state) {
        return _objectSpread({}, state, {
            order: order,
            page: DEFAULT_VALUE.page
        });
    });
};
var setWorkMode = function(workMode) {
    return jobsShowcaseFiltersStore.update(function(state) {
        return _objectSpread({}, state, {
            workMode: workMode,
            page: DEFAULT_VALUE.page
        });
    });
};
var setSeniority = function(seniority) {
    return jobsShowcaseFiltersStore.update(function(state) {
        return _objectSpread({}, state, {
            seniority: seniority,
            page: DEFAULT_VALUE.page
        });
    });
};
var setTechs = function(techs) {
    return jobsShowcaseFiltersStore.update(function(state) {
        return _objectSpread({}, state, {
            techs: techs,
            page: DEFAULT_VALUE.page
        });
    });
};
var setType = function(type) {
    return jobsShowcaseFiltersStore.update(function(state) {
        return _objectSpread({}, state, {
            type: type,
            page: DEFAULT_VALUE.page
        });
    });
};
var setPage = function(page) {
    return jobsShowcaseFiltersStore.update(function(state) {
        return _objectSpread({}, state, {
            page: page
        });
    });
};
function useJobFilters() {
    var ref = _slicedToArray((0,_ngneat_react_rxjs__WEBPACK_IMPORTED_MODULE_0__/* .useObservable */ .mA)($filters), 1), filters = ref[0];
    return {
        filters: filters,
        setCompanyLocation: setCompanyLocation,
        setFocuses: setFocuses,
        setCity: setCity,
        setMaxSalary: setMaxSalary,
        setMinSalary: setMinSalary,
        setOrder: setOrder,
        setWorkMode: setWorkMode,
        setSeniority: setSeniority,
        setTechs: setTechs,
        setType: setType,
        setPage: setPage,
        setFilters: setFilters
    };
}


/***/ }),

/***/ 17132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pg": function() { return /* binding */ SALARY_DEFAULT_MIN; },
/* harmony export */   "N7": function() { return /* binding */ SALARY_DEFAULT_MAX; }
/* harmony export */ });
/* unused harmony exports defaultInitialValues, searchCandidateFiltersAtom, dynamicSkillFilterItems, dynamicWorkCityFilterItems, dynamicLivingCityFilterItems, dynamicLanguageFilterItems, availableFocusesFilterItems, useSearchCandidateFilter */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62661);


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var SALARY_DEFAULT_MIN = 0;
var SALARY_DEFAULT_MAX = 1000000;
var defaultInitialValues = {
    livingCities: [],
    workCities: [],
    languages: [],
    focus: [],
    careerSlugs: [],
    keywords: '',
    salaryRange: undefined,
    workTypes: undefined,
    workRemote: [],
    skills: [],
    available: true,
    situation: 3,
    orderFilter: 'updated_profile',
    page: 1,
    genders: [],
    specialNecessities: [],
    educationLevel: 'all'
};
var searchCandidateFiltersAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)(defaultInitialValues);
var dynamicSkillFilterItems = (0,jotai__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)([]);
var dynamicWorkCityFilterItems = (0,jotai__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)([]);
var dynamicLivingCityFilterItems = (0,jotai__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)([]);
var dynamicLanguageFilterItems = (0,jotai__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)([]);
var availableFocusesFilterItems = (0,jotai__WEBPACK_IMPORTED_MODULE_1__/* .atom */ .cn)([]);
function useSearchCandidateFilter(key) {
    var ref = _slicedToArray(useAtom(searchCandidateFiltersAtom), 2), filterState = ref[0], setFilterState = ref[1];
    var filterValue = filterState[key];
    var handleOnChange = useCallback(function(value) {
        setFilterState(function(s) {
            var _obj;
            return _objectSpread({}, s, (_obj = {}, _defineProperty(_obj, key, value), _defineProperty(_obj, "page", 1), _obj));
        });
    }, [
        setFilterState,
        key
    ]);
    var payload = useMemo(function() {
        return [
            filterValue,
            handleOnChange
        ];
    }, [
        handleOnChange,
        filterValue
    ]);
    return payload;
}


/***/ }),

/***/ 20477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ candidateColorScheme; }
/* harmony export */ });
var candidateColorScheme = {
    errors: {
        100: '#FB5A82',
        200: '#B81A4C'
    },
    primary: {
        100: '#F0F0FF',
        200: '#9412DC',
        150: '#f1ddfc',
        300: '#C570F3',
        400: '#F7E7FF',
        500: '#9412DC',
        700: '#6E2B77'
    },
    secondary: {
        100: '#E0FBF6',
        200: '#41A9B9'
    },
    background: {
        50: '#FAFAFA',
        100: '#F0F1F2',
        200: '#CBD5E0',
        400: '#939DA5',
        700: '#202024',
        800: '#18171B',
        900: '#040c10'
    },
    text: {
        100: '#FFFFFF',
        200: '#acacad',
        300: '#11273a',
        400: '#1F7161',
        600: '#667078',
        700: '#586169',
        900: '#11273A'
    }
};


/***/ }),

/***/ 19266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ formatCity; }
/* harmony export */ });
/**
 * format city name replacing ' -' for ','
 *
 * @param cityWithState
 * @returns {string}
 */ var formatCity = function(city) {
    return city.replace(/\s-(?=[^-]*$)/, ',');
};


/***/ }),

/***/ 28611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ formatTechs; }
/* harmony export */ });
/* harmony import */ var lib_constants_paths__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29770);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var formatTechs = function(techs) {
    var displayTechs = techs.slice(0, 3).map(function(tech) {
        var result = _objectSpread({}, tech);
        result.urlPath = lib_constants_paths__WEBPACK_IMPORTED_MODULE_0__/* .TECHS_JOBS */ .uT(tech.urlPath);
        return result;
    });
    if (techs.length > 3) {
        displayTechs.push({
            name: "+ ".concat(techs.length - 3),
            urlPath: lib_constants_paths__WEBPACK_IMPORTED_MODULE_0__/* .JOBS */ .WN
        });
    }
    return displayTechs;
};


/***/ }),

/***/ 75616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(22319);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(75332);
// EXTERNAL MODULE: ./src/lib/settings/theme/colors/candidate.ts
var candidate = __webpack_require__(20477);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(44453);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(34237);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/chakra-ui-media-query.esm.js
var chakra_ui_media_query_esm = __webpack_require__(52970);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/skeleton/dist/chakra-ui-skeleton.esm.js
var chakra_ui_skeleton_esm = __webpack_require__(15823);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./src/components/atoms/heading/index.tsx
var heading = __webpack_require__(68590);
// EXTERNAL MODULE: ./src/components/organisms/footer/index.tsx + 3 modules
var footer = __webpack_require__(81241);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/chakra-ui-form-control.esm.js
var chakra_ui_form_control_esm = __webpack_require__(11860);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(20570);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/components/atoms/button/index.tsx + 7 modules
var atoms_button = __webpack_require__(65186);
// EXTERNAL MODULE: ./src/components/atoms/form/fieldTitle/index.tsx + 6 modules
var fieldTitle = __webpack_require__(52527);
// EXTERNAL MODULE: ./src/components/atoms/salaryRange/index.tsx + 1 modules
var salaryRange = __webpack_require__(9123);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/slider/dist/chakra-ui-slider.esm.js
var chakra_ui_slider_esm = __webpack_require__(76103);
;// CONCATENATED MODULE: ./src/components/molecules/form/rangeSlider/index.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var RangeSlider = function(_param) {
    var min = _param.min, max = _param.max, defaultValue = _param.defaultValue, onChangeEnd = _param.onChangeEnd, onChange = _param.onChange, value = _param.value, props = _objectWithoutProperties(_param, [
        "min",
        "max",
        "defaultValue",
        "onChangeEnd",
        "onChange",
        "value"
    ]);
    var handleOnChangeEnd = (0,react.useCallback)(function(valueOnChangeEnd) {
        onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd(valueOnChangeEnd);
    }, [
        onChangeEnd
    ]);
    var handleOnChange = (0,react.useCallback)(function(valueOnChange) {
        onChange === null || onChange === void 0 ? void 0 : onChange(valueOnChange);
    }, [
        onChange
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_slider_esm/* RangeSlider */.U2, _objectSpread({
        min: min,
        max: max,
        onChangeEnd: handleOnChangeEnd,
        onChange: handleOnChange,
        defaultValue: defaultValue,
        value: value
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_slider_esm/* RangeSliderTrack */.ug, {
                bg: "purple.300",
                outlineOffset: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_slider_esm/* RangeSliderFilledTrack */.I2, {
                    bg: "primary.500"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_slider_esm/* RangeSliderThumb */.xW, {
                boxSize: 5,
                index: 0,
                outlineOffset: 0,
                outlineColor: "primary.500",
                outline: "solid 1.5px",
                borderRadius: "50%",
                zIndex: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                    color: "primary.500",
                    spacing: 0.5,
                    columns: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                            h: "11px",
                            borderRight: "1px",
                            color: "primary.500"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                            h: "9px",
                            borderRight: "1px",
                            color: "primary.500",
                            alignSelf: "center"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_slider_esm/* RangeSliderThumb */.xW, {
                boxSize: 5,
                index: 1,
                outlineOffset: 0,
                outlineColor: "primary.500",
                outline: "solid 1.5px",
                borderRadius: "50%",
                zIndex: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                    color: "primary.500",
                    spacing: 0.5,
                    columns: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                            h: "9px",
                            borderRight: "1px",
                            color: "primary.500",
                            alignSelf: "center"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                            h: "11px",
                            borderRight: "1px",
                            color: "primary.500"
                        })
                    ]
                })
            })
        ]
    })));
};


// EXTERNAL MODULE: ./node_modules/chakra-react-select/dist/esm/index.js + 46 modules
var esm = __webpack_require__(16936);
;// CONCATENATED MODULE: ./src/components/molecules/jobs/filters/asyncSelect/index.tsx



function asyncSelect_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function asyncSelect_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            asyncSelect_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function asyncSelect_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = asyncSelect_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function asyncSelect_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var AsyncSelect = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref1) {
    var label = _param.label, props = asyncSelect_objectWithoutProperties(_param, [
        "label"
    ]);
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(esm/* AsyncSelect */.qb, asyncSelect_objectSpread({}, props, {
        "aria-label": label,
        errorBorderColor: "errors.200",
        getOptionLabel: function(option) {
            var ref;
            return ((ref = option) === null || ref === void 0 ? void 0 : ref.text) || '';
        },
        loadingMessage: function() {
            return 'Buscando...';
        },
        noOptionsMessage: function() {
            return 'Nenhum resultado encontrado.';
        },
        ref: ref1,
        chakraStyles: {
            control: function(provided) {
                return asyncSelect_objectSpread({}, provided, {
                    borderColor: 'background.200',
                    borderRadius: 2,
                    cursor: 'pointer',
                    fontSize: 14,
                    fontWeight: 600,
                    _hover: {
                        borderColor: 'background.300'
                    },
                    _focus: {
                        borderColor: 'background.300'
                    }
                });
            },
            singleValue: function(provided) {
                return asyncSelect_objectSpread({}, provided, {
                    color: 'primary.500'
                });
            },
            multiValue: function(provided) {
                return asyncSelect_objectSpread({}, provided, {
                    color: 'primary.500',
                    bgColor: 'purple.200'
                });
            },
            option: function(provided, state) {
                return asyncSelect_objectSpread({}, provided, {
                    color: 'text.900',
                    fontSize: 14,
                    fontWeight: state.isSelected ? 700 : 400,
                    _hover: {
                        bgColor: 'primary.150'
                    }
                });
            },
            placeholder: function(provided) {
                return asyncSelect_objectSpread({}, provided, {
                    color: 'text.200'
                });
            },
            dropdownIndicator: function(provided) {
                return asyncSelect_objectSpread({}, provided, {
                    padding: 2,
                    bgColor: 'transparent',
                    color: 'primary.500'
                });
            },
            clearIndicator: function(provided) {
                return asyncSelect_objectSpread({}, provided, {
                    color: 'primary.500',
                    fontSize: 10
                });
            }
        }
    }));
});

AsyncSelect.displayName = 'AsyncSelect';

// EXTERNAL MODULE: ./src/components/molecules/jobs/filters/asyncSelectFocus/index.tsx + 1 modules
var asyncSelectFocus = __webpack_require__(41758);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/checkbox/dist/chakra-ui-checkbox.esm.js
var chakra_ui_checkbox_esm = __webpack_require__(23434);
;// CONCATENATED MODULE: ./src/components/molecules/jobs/filters/options/index.tsx


function options_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function options_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            options_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function options_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = options_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function options_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Options = function(_param) /*#__PURE__*/ {
    var options = _param.options, stackProps = _param.stackProps, props = options_objectWithoutProperties(_param, [
        "options",
        "stackProps"
    ]);
    return (0,jsx_runtime.jsx)(chakra_ui_checkbox_esm/* CheckboxGroup */.cO, options_objectSpread({
        colorScheme: "primary"
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Stack */.Kq, options_objectSpread({
            spacing: 4,
            direction: "row",
            wrap: "wrap"
        }, stackProps, {
            children: options.map(function(option) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_checkbox_esm/* Checkbox */.XZ, {
                    borderColor: "background.400",
                    color: "text.900",
                    iconColor: "text.100",
                    value: option.value,
                    mr: 4,
                    children: option.label
                }, option.value);
            })
        }))
    }));
};


// EXTERNAL MODULE: ./src/lib/constants/enums/jobExperienceLevel.ts
var jobExperienceLevel = __webpack_require__(13346);
// EXTERNAL MODULE: ./src/lib/generated/graphql/index.tsx
var graphql = __webpack_require__(16402);
// EXTERNAL MODULE: ./src/lib/repositories/jobsShowcaseFilters/index.ts
var jobsShowcaseFilters = __webpack_require__(47953);
;// CONCATENATED MODULE: ./src/components/organisms/jobs/filters/desktop/index.tsx















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function desktop_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function desktop_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            desktop_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var DesktopFilters = function(param1) {
    var handleSearchJobs = param1.handleSearchJobs, defaultSalaryValues = param1.defaultSalaryValues;
    var ref7, ref1, ref2;
    var ref3 = (0,jobsShowcaseFilters/* useJobFilters */.VP)(), filters = ref3.filters, setFilters = ref3.setFilters, setCompanyLocation = ref3.setCompanyLocation, setCity = ref3.setCity, setTechs = ref3.setTechs, setType = ref3.setType, setWorkMode = ref3.setWorkMode, setSeniority = ref3.setSeniority;
    var ref4 = _slicedToArray((0,graphql/* useSearchCitiesLazyQuery */.FHg)(), 1), getCities = ref4[0];
    var ref5 = _slicedToArray((0,graphql/* useSearchTechsLazyQuery */.q5Q)(), 1), getTechs = ref5[0];
    var ref6 = (0,react.useState)([
        defaultSalaryValues[0],
        defaultSalaryValues[1], 
    ]), salaryRangeValue = ref6[0], setSalaryRangeValue = ref6[1];
    var showResetFilter = filters.city || filters.techs && ((ref7 = filters.techs) === null || ref7 === void 0 ? void 0 : ref7.length) > 0 || filters.workMode !== undefined && filters.workMode.length > 0 || filters.type !== undefined && filters.type.length > 0 || filters.seniority !== undefined && filters.seniority.length > 0 || filters.companyLocation !== undefined && ((ref1 = filters.companyLocation) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 || filters.minSalary && filters.minSalary !== defaultSalaryValues[0] || filters.minSalary && filters.maxSalary !== defaultSalaryValues[1];
    var handleSalaryChange = function(value) {
        setSalaryRangeValue(value);
    };
    var handleSalaryChangeEnd = function(param) {
        var _param = _slicedToArray(param, 2), min = _param[0], max = _param[1];
        return setFilters(desktop_objectSpread({}, filters, {
            maxSalary: max,
            minSalary: min
        }));
    };
    var handleCityChange = function(newValue) {
        return setCity(newValue);
    };
    var handleTechsChange = function(newValue) {
        return setTechs(newValue);
    };
    var handleSeniorityChange = function(e) {
        return setSeniority(e);
    };
    var handleWorkModeChange = function(e) {
        return setWorkMode(e);
    };
    var handleCompanyLocationChange = function(e) {
        if (JSON.stringify(e) === JSON.stringify([
            graphql/* CompanyLocationEnum.Us */.L0m.Us
        ])) {
            filters.workMode = [];
            filters.city = null;
        }
        setCompanyLocation(e);
    };
    var resetFilter = function() {
        filters.companyLocation = [];
        filters.city = null;
        filters.type = [];
        filters.techs = null;
        filters.focuses = [];
        handleTechsChange(null);
        filters.workMode = [];
        filters.seniority = [];
        var ref;
        ref = _slicedToArray(defaultSalaryValues, 2), filters.minSalary = ref[0], filters.maxSalary = ref[1], ref;
        setSalaryRangeValue(defaultSalaryValues);
        handleSalaryChangeEnd(defaultSalaryValues);
    };
    var loadCityOptions = debounce_default()(function(value, callBack) {
        return getCities({
            variables: {
                textSearch: value
            }
        }).then(function(response) {
            var ref;
            return callBack(((ref = response.data) === null || ref === void 0 ? void 0 : ref.searchCities.map(function(tech) {
                return {
                    text: tech.name,
                    value: tech.id
                };
            })) || []);
        });
    }, 500);
    var loadTechOptions = debounce_default()(function(value, callback) {
        getTechs({
            variables: {
                textSearch: value
            }
        }).then(function(response) {
            var ref;
            return callback(((ref = response.data) === null || ref === void 0 ? void 0 : ref.searchTechs.map(function(tech) {
                return {
                    text: tech.name,
                    value: tech.id
                };
            })) || []);
        });
    }, 500);
    (0,react.useEffect)(function() {
        setSalaryRangeValue([
            defaultSalaryValues[0],
            defaultSalaryValues[1]
        ]);
    }, [
        defaultSalaryValues
    ]);
    var worksWithSkills = function(focuses) {
        return focuses === null || focuses === void 0 ? void 0 : focuses.some(function(focus) {
            var ref;
            return (ref = focus.career) === null || ref === void 0 ? void 0 : ref.worksWithSkills;
        });
    };
    var showSkillFilter = !filters.focuses || ((ref2 = filters.focuses) === null || ref2 === void 0 ? void 0 : ref2.length) === 0 || worksWithSkills(filters.focuses);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
        direction: "column",
        bgColor: "white",
        borderRadius: 2,
        h: "max-content",
        p: 8,
        w: "full",
        spacing: 6,
        align: "flex-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* default */.Z, {
                        color: "text.900",
                        fontSize: "lg",
                        letterSpacing: "normal",
                        fontWeight: 700,
                        format: "h4",
                        pt: 0,
                        m: 0,
                        children: "Filtre sua busca"
                    }),
                    showResetFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        ml: 2,
                        fontSize: "xs",
                        fontWeight: 400,
                        letterSpacing: "tight",
                        color: "primary.500",
                        textDecoration: "underline",
                        cursor: "pointer",
                        onClick: resetFilter,
                        children: "Limpar"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldTitle/* FieldTitle */.m, {
                        mb: 1,
                        label: "Localiza\xe7\xe3o da empresa",
                        fontSize: 14,
                        fontWeight: 700,
                        color: "text.900"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Options, {
                        value: filters.companyLocation,
                        options: [
                            {
                                label: 'Brasil',
                                value: graphql/* CompanyLocationEnum.Brazil */.L0m.Brazil
                            },
                            {
                                label: 'Fora do Brasil',
                                value: graphql/* CompanyLocationEnum.Us */.L0m.Us
                            }, 
                        ],
                        onChange: handleCompanyLocationChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(asyncSelectFocus/* AsyncSelectFocus */._, {
                        onlyActiveJobs: true
                    }),
                    showSkillFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldTitle/* FieldTitle */.m, {
                        label: "Habilidades",
                        fontSize: 14,
                        fontWeight: 700,
                        mt: 4,
                        mb: 2,
                        color: "text.900"
                    }),
                    showSkillFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncSelect, {
                        isMulti: true,
                        label: "Tecnologias",
                        loadOptions: loadTechOptions,
                        name: "order",
                        onChange: handleTechsChange,
                        placeholder: "Selecione as Habilidades",
                        selectedOptionStyle: "check",
                        value: filters.techs,
                        isClearable: true,
                        openMenuOnClick: true,
                        defaultOptions: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldTitle/* FieldTitle */.m, {
                        color: "text.900",
                        mb: 2,
                        label: "Tipo de vaga"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Options, {
                        value: filters.type,
                        options: [
                            {
                                label: 'Remoto',
                                value: 'remote'
                            },
                            {
                                label: 'Presencial',
                                value: 'no_remote'
                            }, 
                        ],
                        onChange: function(e) {
                            return setType(e);
                        }
                    })
                ]
            }),
            JSON.stringify(filters.companyLocation) !== JSON.stringify([
                graphql/* CompanyLocationEnum.Us */.L0m.Us
            ]) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldTitle/* FieldTitle */.m, {
                        label: "Cidade da empresa",
                        fontSize: 14,
                        fontWeight: 700,
                        mb: 2,
                        color: "text.900"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncSelect, {
                        label: "Cidade da empresa",
                        loadOptions: loadCityOptions,
                        name: "order",
                        placeholder: "Digite e selecione uma op\xe7\xe3o",
                        selectedOptionStyle: "check",
                        value: filters.city,
                        onChange: handleCityChange,
                        isMulti: false,
                        isClearable: true,
                        openMenuOnClick: false,
                        defaultOptions: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                        alignItems: "center",
                        mb: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldTitle/* FieldTitle */.m, {
                            color: "text.900",
                            m: 0,
                            pr: 2,
                            label: "N\xedvel de Experi\xeancia"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Options, {
                        value: filters.seniority,
                        options: jobExperienceLevel/* jobExperienceLevelOptions */.sC,
                        onChange: handleSeniorityChange,
                        stackProps: {
                            direction: 'column',
                            spacing: 0
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldTitle/* FieldTitle */.m, {
                        color: "text.900",
                        mb: 2,
                        label: "Regime de trabalho"
                    }),
                    JSON.stringify(filters.companyLocation) !== JSON.stringify([
                        graphql/* CompanyLocationEnum.Us */.L0m.Us
                    ]) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Options, {
                        value: filters.workMode,
                        options: [
                            {
                                label: 'CLT',
                                value: graphql/* WorkModeEnum.Clt */.IBT.Clt
                            },
                            {
                                label: 'PJ ou Cooperativa',
                                value: graphql/* WorkModeEnum.Pj */.IBT.Pj
                            }, 
                        ],
                        onChange: handleWorkModeChange
                    }),
                    JSON.stringify(filters.companyLocation) === JSON.stringify([
                        graphql/* CompanyLocationEnum.Us */.L0m.Us
                    ]) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Options, {
                        value: filters.workMode,
                        options: [
                            {
                                label: 'PJ ou Cooperativa',
                                value: graphql/* WorkModeEnum.Pj */.IBT.Pj
                            }
                        ],
                        onChange: handleWorkModeChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldTitle/* FieldTitle */.m, {
                        color: "text.900",
                        mb: 2,
                        label: "Faixa de remunera\xe7\xe3o mensal"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(salaryRange/* SalaryRange */.m, {
                        minSalary: salaryRangeValue[0],
                        maxSalary: salaryRangeValue[1],
                        currency: "R$",
                        suffix: salaryRange/* SalarySuffixTypes.None */.l.None,
                        isFilter: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        px: 3,
                        mt: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeSlider, {
                            min: defaultSalaryValues[0],
                            max: defaultSalaryValues[1],
                            onChangeEnd: handleSalaryChangeEnd,
                            onChange: handleSalaryChange,
                            value: salaryRangeValue,
                            defaultValue: [
                                filters.minSalary || defaultSalaryValues[0],
                                filters.maxSalary || defaultSalaryValues[1], 
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                w: "full",
                onClick: function() {
                    return handleSearchJobs();
                },
                children: "Filtrar"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/chakra-ui-icon.esm.js
var chakra_ui_icon_esm = __webpack_require__(95196);
// EXTERNAL MODULE: ./node_modules/react-in-viewport/dist/es/index.js
var es = __webpack_require__(74009);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var index_esm = __webpack_require__(80145);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(50167);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/chakra-ui-hooks.esm.js
var chakra_ui_hooks_esm = __webpack_require__(27446);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js
var chakra_ui_button_esm = __webpack_require__(65618);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chakra-ui-modal.esm.js + 56 modules
var chakra_ui_modal_esm = __webpack_require__(25215);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(45666);
// EXTERNAL MODULE: ./src/components/atoms/mobileTooltip/index.tsx
var mobileTooltip = __webpack_require__(95307);
;// CONCATENATED MODULE: ./src/components/molecules/jobs/filters/mobile/card/index.tsx









function card_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function card_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            card_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function card_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = card_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function card_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var MobileFilterCard = function(_param) {
    var label = _param.label, title = _param.title, children = _param.children, resetFilter = _param.resetFilter, showResetFilter = _param.showResetFilter, tooltipContent = _param.tooltipContent, showTooltip = _param.showTooltip, handleSearchJobs = _param.handleSearchJobs, isActive = _param.isActive, props = card_objectWithoutProperties(_param, [
        "label",
        "title",
        "children",
        "resetFilter",
        "showResetFilter",
        "tooltipContent",
        "showTooltip",
        "handleSearchJobs",
        "isActive"
    ]);
    var ref = (0,jobsShowcaseFilters/* useJobFilters */.VP)(), filters = ref.filters, setFilters = ref.setFilters;
    var ref1 = (0,chakra_ui_hooks_esm/* useDisclosure */.qY)(), isOpen = ref1.isOpen, onOpen = ref1.onOpen, onClose = ref1.onClose;
    var ref2 = (0,react.useState)(false), shouldReset = ref2[0], setShouldReset = ref2[1];
    var ref3 = (0,react.useState)(card_objectSpread({}, jobsShowcaseFilters/* DEFAULT_VALUE */.PW)), filterSnapshot = ref3[0], setFilterSnapshot = ref3[1];
    var handleFilter = (0,react.useCallback)(function() {
        if (handleSearchJobs) handleSearchJobs();
        onClose();
    }, [
        handleSearchJobs,
        onClose
    ]);
    var handleResetFilter = function(e) {
        if (!resetFilter) return;
        e.stopPropagation();
        resetFilter();
        setShouldReset(true);
    };
    var handleOpenModal = function() {
        setFilterSnapshot(card_objectSpread({}, filters));
        onOpen();
    };
    var closeAndRevert = function() {
        setFilters(card_objectSpread({}, filterSnapshot));
        onClose();
    };
    (0,react.useEffect)(function() {
        if (shouldReset) handleFilter();
        setShouldReset(false);
    }, [
        filters,
        handleFilter,
        shouldReset
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                bgColor: isActive ? 'primary.150' : 'white',
                borderColor: isActive ? 'primary.500' : 'grey.100',
                borderRadius: 18,
                borderWidth: 1,
                color: isActive ? 'primary.500' : 'text.700',
                fontSize: 14,
                fontWeight: 600,
                _hover: {
                    borderColor: isActive ? 'primary.500' : 'text.700'
                },
                _focus: {
                    borderColor: isActive ? 'primary.500' : 'text.700'
                },
                rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaAngleDown */.iUH, {
                            color: isActive ? 'primary.500' : '',
                            style: {
                                marginTop: '3px',
                                marginLeft: '-5px'
                            }
                        }),
                        showResetFilter && isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosCloseCircle */.FMH, {
                            onClick: handleResetFilter,
                            style: {
                                marginLeft: '6px',
                                width: '18px',
                                height: '18px'
                            }
                        }) : null
                    ]
                }),
                onClick: handleOpenModal,
                px: 3,
                py: 2,
                flexShrink: "0",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_modal_esm/* Drawer */.dy, {
                placement: "bottom",
                onClose: closeAndRevert,
                isOpen: isOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_modal_esm/* DrawerOverlay */.P1, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_modal_esm/* DrawerContent */.sc, card_objectSpread({
                        maxH: "-webkit-fill-available",
                        borderTopRadius: "base",
                        p: 5
                    }, props, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_modal_esm/* DrawerCloseButton */.cC, {
                                mt: 3,
                                mr: 3
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_modal_esm/* DrawerHeader */.OX, {
                                p: 0,
                                mb: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                                    flexDirection: "row",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* default */.Z, {
                                            pt: 0,
                                            ml: 0,
                                            my: 0,
                                            mr: 2,
                                            letterSpacing: "tight",
                                            fontFamily: "'Poppins', sans-serif",
                                            format: "h2",
                                            fontWeight: 600,
                                            color: "text.900",
                                            children: title
                                        }),
                                        showTooltip ? /*#__PURE__*/ (0,jsx_runtime.jsx)(mobileTooltip/* MobileTooltip */.e, {
                                            showBackground: false,
                                            mr: 5,
                                            children: tooltipContent
                                        }) : null,
                                        showResetFilter && isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                            fontSize: "xs",
                                            fontWeight: 400,
                                            letterSpacing: "tight",
                                            color: "primary.500",
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                            onClick: resetFilter,
                                            children: "Limpar"
                                        }) : null
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_modal_esm/* DrawerBody */.Ng, {
                                p: 0,
                                children: children
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_modal_esm/* DrawerFooter */.ze, {
                                p: 0,
                                mt: 7,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                    w: "100%",
                                    size: "xl",
                                    onClick: handleFilter,
                                    children: "Confirmar"
                                })
                            })
                        ]
                    }))
                ]
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/lib/constants/order.ts

var orderOptions = [
    {
        text: 'Mais recentes',
        value: graphql/* OrderEnum.Newer */.lzH.Newer
    },
    {
        text: 'Mais antigas',
        value: graphql/* OrderEnum.Older */.lzH.Older
    },
    {
        text: 'Maior remunera\xe7\xe3o',
        value: graphql/* OrderEnum.MaxSalary */.lzH.MaxSalary
    },
    {
        text: 'Menor remunera\xe7\xe3o',
        value: graphql/* OrderEnum.MinSalary */.lzH.MinSalary
    }, 
];

;// CONCATENATED MODULE: ./src/components/molecules/jobs/filters/mobile/order/index.tsx






var Order = function() {
    var ref = (0,jobsShowcaseFilters/* useJobFilters */.VP)(), filters = ref.filters, setOrder = ref.setOrder;
    var orderSelectedLabel = orderOptions.find(function(o) {
        return o.value === filters.order;
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilterCard, {
        isActive: true,
        showTooltip: false,
        showResetFilter: false,
        label: (orderSelectedLabel === null || orderSelectedLabel === void 0 ? void 0 : orderSelectedLabel.text) || orderOptions[0].text,
        title: "Ordenar por",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* VStack */.gC, {
            spacing: 4,
            align: "start",
            children: orderOptions.map(function(o) {
                var isSelected = o.value === filters.order;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                    onClick: function() {
                        return setOrder(o.value);
                    },
                    color: isSelected ? 'primary.500' : 'text.900',
                    fontSize: 14,
                    fontWeight: isSelected ? 700 : 400,
                    display: "flex",
                    alignItems: "center",
                    children: [
                        o.text,
                        isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, {
                            as: fi_index_esm/* FiCheck */.UgA,
                            ml: 2,
                            color: isSelected ? 'primary.500' : 'text.900',
                            fontWeight: isSelected ? 700 : 400
                        })
                    ]
                }, o.value));
            })
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/molecules/jobs/filters/mobile/salary/index.tsx







function salary_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function salary_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function salary_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function salary_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function salary_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function salary_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            salary_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function salary_slicedToArray(arr, i) {
    return salary_arrayWithHoles(arr) || salary_iterableToArrayLimit(arr, i) || salary_unsupportedIterableToArray(arr, i) || salary_nonIterableRest();
}
function salary_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return salary_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return salary_arrayLikeToArray(o, minLen);
}
var Salary = function(param1) {
    var handleSearchJobs = param1.handleSearchJobs, defaultSalaryValues = param1.defaultSalaryValues;
    var ref = (0,jobsShowcaseFilters/* useJobFilters */.VP)(), filters = ref.filters, setFilters = ref.setFilters;
    var ref1 = (0,react.useState)([
        defaultSalaryValues[0],
        defaultSalaryValues[1], 
    ]), salaryRangeValue = ref1[0], setSalaryRangeValue = ref1[1];
    var onValueChangeEnd = function(param) {
        var _param = salary_slicedToArray(param, 2), min = _param[0], max = _param[1];
        setFilters(salary_objectSpread({}, filters, {
            maxSalary: max,
            minSalary: min
        }));
    };
    var onValueChange = function(value) {
        setSalaryRangeValue(value);
    };
    var resetFilter = function() {
        setFilters(salary_objectSpread({}, filters, {
            minSalary: defaultSalaryValues[0],
            maxSalary: defaultSalaryValues[1]
        }));
        setSalaryRangeValue([
            defaultSalaryValues[0],
            defaultSalaryValues[1]
        ]);
    };
    (0,react.useEffect)(function() {
        setSalaryRangeValue([
            filters.minSalary || defaultSalaryValues[0],
            filters.maxSalary || defaultSalaryValues[1], 
        ]);
    }, [
        defaultSalaryValues,
        filters.minSalary,
        filters.maxSalary
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileFilterCard, {
        isActive: filters.minSalary !== defaultSalaryValues[0] && filters.minSalary !== undefined || filters.maxSalary !== defaultSalaryValues[1] && filters.maxSalary !== undefined,
        showTooltip: false,
        showResetFilter: true,
        resetFilter: resetFilter,
        label: "Remunera\xe7\xe3o",
        title: "Remunera\xe7\xe3o",
        handleSearchJobs: handleSearchJobs,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                fontWeight: 600,
                children: "Faixa de remunera\xe7\xe3o mensal"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(salaryRange/* SalaryRange */.m, {
                minSalary: salaryRangeValue[0],
                maxSalary: salaryRangeValue[1],
                currency: "R$",
                suffix: salaryRange/* SalarySuffixTypes.None */.l.None
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                px: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeSlider, {
                    min: defaultSalaryValues[0],
                    max: defaultSalaryValues[1],
                    onChangeEnd: onValueChangeEnd,
                    onChange: onValueChange,
                    value: salaryRangeValue,
                    defaultValue: [
                        filters.minSalary || defaultSalaryValues[0],
                        filters.maxSalary || defaultSalaryValues[1], 
                    ],
                    mt: 9
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 5 modules
var chakra_ui_system_esm = __webpack_require__(47386);
;// CONCATENATED MODULE: ./src/components/atoms/form/customBadgeCheckbox/index.tsx


function customBadgeCheckbox_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function customBadgeCheckbox_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            customBadgeCheckbox_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function customBadgeCheckbox_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = customBadgeCheckbox_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function customBadgeCheckbox_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var CustomBadgeCheckbox = function(_param) {
    var label = _param.label, props = customBadgeCheckbox_objectWithoutProperties(_param, [
        "label"
    ]);
    var ref = (0,chakra_ui_checkbox_esm/* useCheckbox */.O)(props), state = ref.state, getInputProps = ref.getInputProps, getLabelProps = ref.getLabelProps, htmlProps = ref.htmlProps, getCheckboxProps = ref.getCheckboxProps;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, customBadgeCheckbox_objectSpread({}, getCheckboxProps, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_system_esm/* chakra.label */.m$.label, customBadgeCheckbox_objectSpread({
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gridColumnGap: 2,
            w: "fit-content",
            bgColor: state.isChecked ? 'purple.200' : 'white.100',
            borderColor: state.isChecked ? 'primary.500' : 'grey.200',
            borderRadius: 18,
            borderWidth: 1,
            color: state.isChecked ? 'primary.500' : 'grey.200',
            fontSize: 14,
            cursor: "pointer",
            px: 4,
            py: 1.5
        }, htmlProps, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", customBadgeCheckbox_objectSpread({}, getInputProps(), {
                    hidden: true
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, customBadgeCheckbox_objectSpread({}, getLabelProps(), {
                    children: label
                }))
            ]
        }))
    })));
};


;// CONCATENATED MODULE: ./src/components/molecules/jobs/filters/mobile/seniority/index.tsx






function seniority_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function seniority_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            seniority_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Seniority = function(param) {
    var handleSearchJobs = param.handleSearchJobs;
    var ref;
    var ref1 = (0,jobsShowcaseFilters/* useJobFilters */.VP)(), filters = ref1.filters, setSeniority = ref1.setSeniority;
    var ref2 = (0,chakra_ui_checkbox_esm/* useCheckboxGroup */.u6)({
        defaultValue: filters.seniority || [],
        value: filters.seniority,
        onChange: function(values) {
            setSeniority(values);
        }
    }), setValue = ref2.setValue, getCheckboxProps = ref2.getCheckboxProps;
    var resetFilter = function() {
        setValue([]);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilterCard, {
        isActive: filters.seniority !== undefined && ((ref = filters.seniority) === null || ref === void 0 ? void 0 : ref.length) > 0,
        showTooltip: false,
        showResetFilter: true,
        resetFilter: resetFilter,
        label: "Senioridade",
        title: "Senioridade",
        handleSearchJobs: handleSearchJobs,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* HStack */.Ug, {
            gap: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBadgeCheckbox, seniority_objectSpread({
                    label: "Assistente"
                }, getCheckboxProps({
                    value: graphql/* SeniorityEnum.Assistance */.lJm.Assistance
                }))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBadgeCheckbox, seniority_objectSpread({
                    label: "Est\xe1gio"
                }, getCheckboxProps({
                    value: graphql/* SeniorityEnum.Internship */.lJm.Internship
                }))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBadgeCheckbox, seniority_objectSpread({
                    label: "J\xfanior"
                }, getCheckboxProps({
                    value: graphql/* SeniorityEnum.EntryLevel */.lJm.EntryLevel
                }))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBadgeCheckbox, seniority_objectSpread({
                    label: "Pleno"
                }, getCheckboxProps({
                    value: graphql/* SeniorityEnum.MidLevel */.lJm.MidLevel
                }))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBadgeCheckbox, seniority_objectSpread({
                    label: "S\xeanior"
                }, getCheckboxProps({
                    value: graphql/* SeniorityEnum.SeniorLevel */.lJm.SeniorLevel
                }))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBadgeCheckbox, seniority_objectSpread({
                    label: "Diretor"
                }, getCheckboxProps({
                    value: graphql/* SeniorityEnum.Director */.lJm.Director
                }))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBadgeCheckbox, seniority_objectSpread({
                    label: "Executivo"
                }, getCheckboxProps({
                    value: graphql/* SeniorityEnum.Executive */.lJm.Executive
                })))
            ]
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/chakra-ui-transition.esm.js
var chakra_ui_transition_esm = __webpack_require__(12803);
;// CONCATENATED MODULE: ./src/components/molecules/jobs/filters/mobile/technologies/index.tsx








function technologies_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function technologies_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function technologies_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function technologies_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function technologies_slicedToArray(arr, i) {
    return technologies_arrayWithHoles(arr) || technologies_iterableToArrayLimit(arr, i) || technologies_unsupportedIterableToArray(arr, i) || technologies_nonIterableRest();
}
function technologies_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return technologies_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return technologies_arrayLikeToArray(o, minLen);
}
var Technologies = function(param) {
    var handleSearchJobs = param.handleSearchJobs;
    var ref4;
    var ref1 = (0,jobsShowcaseFilters/* useJobFilters */.VP)(), filters = ref1.filters, setTechs = ref1.setTechs;
    var ref2 = (0,react.useState)(false), show = ref2[0], setShow = ref2[1];
    var ref3 = technologies_slicedToArray((0,graphql/* useSearchTechsLazyQuery */.q5Q)(), 1), getTechs = ref3[0];
    var resetFilter = function() {
        setTechs([]);
    };
    var loadTechOptions = debounce_default()(function(value, callBack) {
        getTechs({
            variables: {
                textSearch: value
            }
        }).then(function(response) {
            var ref;
            return callBack(((ref = response.data) === null || ref === void 0 ? void 0 : ref.searchTechs.map(function(tech) {
                return {
                    text: tech.name,
                    value: tech.id
                };
            })) || []);
        });
    }, 500);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilterCard, {
        isActive: !!(filters.techs && ((ref4 = filters.techs) === null || ref4 === void 0 ? void 0 : ref4.length) > 0),
        showTooltip: false,
        showResetFilter: true,
        resetFilter: resetFilter,
        label: "Habilidades",
        title: "Habilidades",
        handleSearchJobs: handleSearchJobs,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_transition_esm/* Collapse */.UO, {
            startingHeight: 60,
            in: show,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                h: "270",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncSelect, {
                    isMulti: true,
                    label: "Habilidades",
                    loadOptions: loadTechOptions,
                    name: "order",
                    onChange: function(newValue) {
                        return setTechs(newValue);
                    },
                    placeholder: "Selecione as Habilidades",
                    selectedOptionStyle: "check",
                    value: filters.techs,
                    isClearable: true,
                    onMenuOpen: function() {
                        return setShow(true);
                    },
                    onMenuClose: function() {
                        return setShow(false);
                    },
                    defaultOptions: true
                })
            })
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/molecules/jobs/filters/mobile/remote/index.tsx





function remote_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function remote_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            remote_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Remote = function(param) {
    var handleSearchJobs = param.handleSearchJobs;
    var ref1 = (0,jobsShowcaseFilters/* useJobFilters */.VP)(), filters = ref1.filters, setType = ref1.setType;
    var isActive = (0,react.useMemo)(function() {
        var ref;
        return filters.type !== undefined && ((ref = filters.type) === null || ref === void 0 ? void 0 : ref.length) > 0;
    }, [
        filters.type
    ]);
    var handleFilter = function() {
        var type = isActive ? [] : [
            'remote'
        ];
        setType(type);
        handleSearchJobs(remote_objectSpread({}, filters, {
            type: type
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
            bgColor: isActive ? 'primary.150' : 'white',
            borderColor: isActive ? 'primary.500' : 'grey.100',
            borderRadius: 18,
            borderWidth: 1,
            color: isActive ? 'primary.500' : 'text.700',
            fontSize: 14,
            fontWeight: 600,
            _hover: {
                borderColor: isActive ? 'primary.500' : 'text.700'
            },
            _focus: {
                borderColor: isActive ? 'primary.500' : 'text.700'
            },
            rightIcon: isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoIosCloseCircle */.FMH, {
                onClick: function() {
                    return setType([]);
                },
                style: {
                    width: '18px',
                    height: '18px'
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            onClick: handleFilter,
            px: 3,
            py: 2,
            flexShrink: "0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                mr: isActive ? '' : '-8px',
                children: "Remoto"
            })
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/molecules/jobs/filters/mobile/focus/index.tsx




var Focus = function(param) {
    var expands = param.expands, handleSearchJobs = param.handleSearchJobs;
    var ref = (0,jobsShowcaseFilters/* useJobFilters */.VP)(), setFocuses = ref.setFocuses, filters = ref.filters;
    var resetFilter = function() {
        setFocuses([]);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilterCard, {
            isActive: !!filters.focuses && filters.focuses.length > 0,
            showTooltip: false,
            showResetFilter: true,
            resetFilter: resetFilter,
            label: "Foco de Carreira",
            title: "Foco de Carreira",
            handleSearchJobs: handleSearchJobs,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asyncSelectFocus/* AsyncSelectFocus */._, {
                expands: expands,
                onlyActiveJobs: true
            })
        })
    }));
};

;// CONCATENATED MODULE: ./src/lib/constants/salary.ts
var salaryDefaults = {
    min: 1000,
    max: 30000
};

;// CONCATENATED MODULE: ./src/components/molecules/jobs/filters/mobile/advanced/index.tsx












function advanced_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function advanced_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function advanced_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function advanced_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function advanced_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function advanced_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            advanced_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function advanced_slicedToArray(arr, i) {
    return advanced_arrayWithHoles(arr) || advanced_iterableToArrayLimit(arr, i) || advanced_unsupportedIterableToArray(arr, i) || advanced_nonIterableRest();
}
function advanced_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return advanced_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return advanced_arrayLikeToArray(o, minLen);
}
var Advanced = function(param1) {
    var handleSearchJobs = param1.handleSearchJobs, defaultSalaryValues = param1.defaultSalaryValues;
    var ref5 = (0,jobsShowcaseFilters/* useJobFilters */.VP)(), filters = ref5.filters, setType = ref5.setType, setCity = ref5.setCity, setWorkMode = ref5.setWorkMode, setFilters = ref5.setFilters;
    var ref1 = advanced_slicedToArray((0,graphql/* useSearchCitiesLazyQuery */.FHg)(), 1), getCities = ref1[0];
    var loadCityOptions = debounce_default()(function(value, callBack) {
        return getCities({
            variables: {
                textSearch: value
            }
        }).then(function(response) {
            var ref;
            return callBack(((ref = response.data) === null || ref === void 0 ? void 0 : ref.searchCities.map(function(tech) {
                return {
                    text: tech.name,
                    value: tech.id
                };
            })) || []);
        });
    }, 500);
    var ref2 = (0,chakra_ui_checkbox_esm/* useCheckboxGroup */.u6)({
        defaultValue: filters.workMode || [],
        value: filters.workMode,
        onChange: function(values) {
            setWorkMode(values.map(function(item) {
                return item;
            }));
        }
    }), getCheckboxWorkModeProps = ref2.getCheckboxProps;
    var ref3 = (0,chakra_ui_checkbox_esm/* useCheckboxGroup */.u6)({
        defaultValue: filters.type || [],
        value: filters.type,
        onChange: function(values) {
            setType(values.map(function(item) {
                return item;
            }));
        }
    }), getCheckboxTypeProps = ref3.getCheckboxProps;
    var ref4 = (0,react.useState)([
        filters.minSalary || defaultSalaryValues[0],
        filters.maxSalary || defaultSalaryValues[1], 
    ]), salaryRangeValue = ref4[0], setSalaryRangeValue = ref4[1];
    var onValueChangeEnd = function(param) {
        var _param = advanced_slicedToArray(param, 2), min = _param[0], max = _param[1];
        setFilters(advanced_objectSpread({}, filters, {
            maxSalary: max,
            minSalary: min
        }));
    };
    var onValueChange = function(value) {
        setSalaryRangeValue(value);
    };
    var resetFilter = function() {
        setFilters(advanced_objectSpread({}, filters, {
            companyLocation: [],
            minSalary: defaultSalaryValues[0],
            maxSalary: defaultSalaryValues[1],
            seniority: [],
            workMode: [],
            type: [],
            city: null
        }));
        setSalaryRangeValue([
            defaultSalaryValues[0],
            defaultSalaryValues[1]
        ]);
    };
    var salaryFiltered = filters.minSalary !== defaultSalaryValues[0] && filters.minSalary !== undefined || filters.maxSalary !== defaultSalaryValues[1] && filters.maxSalary !== undefined;
    var typeFiltered = filters.type !== undefined && filters.type.length > 0;
    var workModeFiltered = filters.workMode !== undefined && filters.workMode.length > 0;
    var seniorityFiltered = filters.seniority !== undefined && filters.seniority.length > 0;
    var cityFiltered = filters.city !== undefined && filters.city !== null;
    (0,react.useEffect)(function() {
        setSalaryRangeValue([
            filters.minSalary || defaultSalaryValues[0],
            filters.maxSalary || defaultSalaryValues[1], 
        ]);
    }, [
        defaultSalaryValues,
        filters.minSalary,
        filters.maxSalary
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilterCard, {
        showTooltip: false,
        showResetFilter: true,
        resetFilter: resetFilter,
        label: "Filtros Avan\xe7ados",
        title: "Filtros Avan\xe7ados",
        handleSearchJobs: handleSearchJobs,
        isActive: salaryFiltered || typeFiltered || workModeFiltered || seniorityFiltered || cityFiltered,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
            spacing: 6,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            fontWeight: 600,
                            mb: 2,
                            children: "Tipo de Vaga"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* HStack */.Ug, {
                            gap: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBadgeCheckbox, advanced_objectSpread({
                                    label: "Remota"
                                }, getCheckboxTypeProps({
                                    value: 'remote'
                                }))),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBadgeCheckbox, advanced_objectSpread({
                                    label: "Presencial"
                                }, getCheckboxTypeProps({
                                    value: 'no_remote'
                                })))
                            ]
                        })
                    ]
                }),
                JSON.stringify(filters.companyLocation) !== JSON.stringify([
                    graphql/* CompanyLocationEnum.Us */.L0m.Us
                ]) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            fontWeight: 600,
                            mb: 2,
                            children: "Cidade da empresa"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncSelect, {
                            label: "Cidade da empresa",
                            loadOptions: debounce_default()(loadCityOptions, 1000),
                            name: "order",
                            placeholder: "Digite e selecione uma op\xe7\xe3o",
                            selectedOptionStyle: "check",
                            value: filters.city,
                            onChange: function(newValue) {
                                return setCity(newValue);
                            },
                            isMulti: false,
                            isClearable: true,
                            openMenuOnClick: false,
                            defaultOptions: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            fontWeight: 600,
                            mb: 2,
                            children: "Regime de Trabalho"
                        }),
                        JSON.stringify(filters.companyLocation) !== JSON.stringify([
                            graphql/* CompanyLocationEnum.Us */.L0m.Us
                        ]) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* HStack */.Ug, {
                            gap: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBadgeCheckbox, advanced_objectSpread({
                                    label: "CLT"
                                }, getCheckboxWorkModeProps({
                                    value: graphql/* WorkModeEnum.Clt */.IBT.Clt
                                }))),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBadgeCheckbox, advanced_objectSpread({
                                    label: "PJ ou Cooperativa"
                                }, getCheckboxWorkModeProps({
                                    value: graphql/* WorkModeEnum.Pj */.IBT.Pj
                                })))
                            ]
                        }),
                        JSON.stringify(filters.companyLocation) === JSON.stringify([
                            graphql/* CompanyLocationEnum.Us */.L0m.Us
                        ]) && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* HStack */.Ug, {
                            gap: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBadgeCheckbox, advanced_objectSpread({
                                label: "PJ ou Cooperativa"
                            }, getCheckboxWorkModeProps({
                                value: graphql/* WorkModeEnum.Pj */.IBT.Pj
                            })))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            fontWeight: 600,
                            children: "Faixa de remunera\xe7\xe3o mensal"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(salaryRange/* SalaryRange */.m, {
                            minSalary: salaryRangeValue[0],
                            maxSalary: salaryRangeValue[1],
                            currency: "R$",
                            suffix: salaryRange/* SalarySuffixTypes.None */.l.None
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                            px: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeSlider, {
                                min: defaultSalaryValues[0] || salaryDefaults.min,
                                max: defaultSalaryValues[1] || salaryDefaults.max,
                                onChangeEnd: onValueChangeEnd,
                                onChange: onValueChange,
                                value: salaryRangeValue,
                                defaultValue: [
                                    filters.minSalary || defaultSalaryValues[0],
                                    filters.maxSalary || defaultSalaryValues[1], 
                                ],
                                mt: 2
                            })
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/molecules/jobs/filters/mobile/companyLocation/index.tsx






function companyLocation_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function companyLocation_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            companyLocation_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var MobileCompanyLocationFilter = function(param) {
    var handleSearchJobs = param.handleSearchJobs;
    var ref;
    var ref1 = (0,jobsShowcaseFilters/* useJobFilters */.VP)(), filters = ref1.filters, setCompanyLocation = ref1.setCompanyLocation;
    var ref2 = (0,chakra_ui_checkbox_esm/* useCheckboxGroup */.u6)({
        defaultValue: filters.companyLocation || [],
        value: filters.companyLocation,
        onChange: function(values) {
            setCompanyLocation(values);
        }
    }), setValue = ref2.setValue, getCheckboxProps = ref2.getCheckboxProps;
    var resetFilter = function() {
        setValue([]);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilterCard, {
        isActive: filters.companyLocation !== undefined && ((ref = filters.companyLocation) === null || ref === void 0 ? void 0 : ref.length) > 0,
        showTooltip: false,
        showResetFilter: true,
        resetFilter: resetFilter,
        label: "Localiza\xe7\xe3o da empresa",
        title: "Localiza\xe7\xe3o da empresa",
        handleSearchJobs: handleSearchJobs,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* HStack */.Ug, {
            gap: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBadgeCheckbox, companyLocation_objectSpread({
                    label: "Brasil"
                }, getCheckboxProps({
                    value: graphql/* CompanyLocationEnum.Brazil */.L0m.Brazil
                }))),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBadgeCheckbox, companyLocation_objectSpread({
                    label: "Fora do Brasil"
                }, getCheckboxProps({
                    value: graphql/* CompanyLocationEnum.Us */.L0m.Us
                })))
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/organisms/jobs/filters/mobile/index.tsx













var MobileFilters = function(param) {
    var defaultSalaryValues = param.defaultSalaryValues, showOrderFilter = param.showOrderFilter, handleSearchJobs = param.handleSearchJobs;
    var fadeOpacityLeft = (0,react.useRef)(null);
    var fadeOpacityRight = (0,react.useRef)(null);
    var ref2 = (0,es/* useInViewport */.NM)(fadeOpacityLeft, {}, {
        disconnectOnLeave: false
    }), inViewportLeft = ref2.inViewport, leaveCount = ref2.leaveCount;
    var ref1 = (0,es/* useInViewport */.NM)(fadeOpacityRight, {}, {
        disconnectOnLeave: false
    }), inViewportRight = ref1.inViewport;
    var handleClick = function() {
        var ref;
        (ref = fadeOpacityRight.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            inline: 'center',
            block: 'end',
            behavior: 'smooth'
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* HStack */.Ug, {
                gap: 0.5,
                overflowX: "scroll",
                sx: {
                    scrollbarWidth: 'none',
                    '::-webkit-scrollbar': {
                        display: 'none'
                    },
                    Mask: "".concat(!inViewportLeft ? 'linear-gradient(to left, #fff 90%, transparent)' : '').concat(!inViewportLeft && !inViewportRight ? ',' : '').concat(!inViewportRight ? 'linear-gradient(to right, #fff 90%, transparent)' : ''),
                    '-webkit-mask': "".concat(!inViewportLeft ? 'linear-gradient(to left, #fff 90%, transparent)' : '').concat(!inViewportLeft && !inViewportRight ? ',' : '').concat(!inViewportRight ? 'linear-gradient(to right, #fff 90%, transparent)' : '')
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        mr: "-8px",
                        ref: fadeOpacityLeft
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileCompanyLocationFilter, {
                        handleSearchJobs: handleSearchJobs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Focus, {
                        handleSearchJobs: handleSearchJobs,
                        expands: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Technologies, {
                        handleSearchJobs: handleSearchJobs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Remote, {
                        handleSearchJobs: handleSearchJobs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Seniority, {
                        handleSearchJobs: handleSearchJobs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Salary, {
                        defaultSalaryValues: defaultSalaryValues,
                        handleSearchJobs: handleSearchJobs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Advanced, {
                        defaultSalaryValues: defaultSalaryValues,
                        handleSearchJobs: handleSearchJobs
                    }),
                    showOrderFilter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Order, {}) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        "data-testid": "filters-right-edge",
                        w: "1px",
                        ml: "-7px",
                        flexShrink: "0",
                        ref: fadeOpacityRight
                    })
                ]
            }),
            !inViewportRight && leaveCount === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, {
                "data-testid": "arrow-icon",
                as: index_esm/* IoIosArrowForward */.hjJ,
                position: "absolute",
                right: "8px",
                color: "primary.500",
                boxSize: "20px",
                onClick: handleClick
            }) : null
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/chakra-ui-spinner.esm.js
var chakra_ui_spinner_esm = __webpack_require__(57885);
// EXTERNAL MODULE: ./node_modules/@choc-ui/paginator/dist/paginator.esm.js
var paginator_esm = __webpack_require__(98978);
;// CONCATENATED MODULE: ./src/components/molecules/jobs/pagination/index.tsx







function pagination_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function pagination_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            pagination_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var PreviousPage = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms_button/* default */.Z, pagination_objectSpread({
        ref: ref
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
            backgroundColor: "primary.500",
            h: "full",
            w: "full",
            borderRadius: "full",
            justifyContent: "center",
            alignItems: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                as: index_esm/* IoIosArrowBack */.u1R,
                color: "white.100",
                width: "20px",
                height: "20px",
                ml: "-2px"
            })
        })
    }));
});
PreviousPage.displayName = 'PreviousPage';
var PreviousPageDisabled = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms_button/* default */.Z, pagination_objectSpread({
        ref: ref
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
            backgroundColor: "grey.600",
            h: "full",
            w: "full",
            borderRadius: "full",
            justifyContent: "center",
            alignItems: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                as: index_esm/* IoIosArrowBack */.u1R,
                color: "white.100",
                width: "20px",
                height: "20px",
                ml: "-2px"
            })
        })
    }));
});
PreviousPageDisabled.displayName = 'PreviousPageDisabled';
var NextPage = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms_button/* default */.Z, pagination_objectSpread({
        "data-testid": "next",
        ref: ref
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
            backgroundColor: "primary.500",
            h: "full",
            w: "full",
            borderRadius: "full",
            justifyContent: "center",
            alignItems: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                as: index_esm/* IoIosArrowForward */.hjJ,
                color: "white.100",
                width: "20px",
                height: "20px",
                mr: "-2px"
            })
        })
    }));
});
NextPage.displayName = 'NextPage';
var NextPageDisabled = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms_button/* default */.Z, pagination_objectSpread({
        ref: ref
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
            backgroundColor: "grey.600",
            h: "full",
            w: "full",
            borderRadius: "full",
            justifyContent: "center",
            alignItems: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                as: index_esm/* IoIosArrowForward */.hjJ,
                color: "white.100",
                width: "20px",
                height: "20px",
                mr: "-2px"
            })
        })
    }));
});
NextPageDisabled.displayName = 'NextPageDisabled';
var EmptyButton = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms_button/* default */.Z, pagination_objectSpread({
        ref: ref
    }, props, {
        children: "..."
    }));
});
EmptyButton.displayName = 'EmptyButton';
var Pagination = function(param) {
    var total = param.total, handleSearchJobs = param.handleSearchJobs;
    var ref = (0,jobsShowcaseFilters/* useJobFilters */.VP)(), filters = ref.filters, setPage = ref.setPage;
    var itemRender = function(_currentPage, type) {
        if (_currentPage === 1 && type === 'prev') return PreviousPageDisabled;
        if (_currentPage === Math.ceil(total / 10) && type === 'next') return NextPageDisabled;
        if (type === 'prev') return PreviousPage;
        if (type === 'next') return NextPage;
        if (type === 'backward' || type === 'forward') return EmptyButton;
        return null;
    };
    var handleOnChange = function(page) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        setPage(page);
        handleSearchJobs(pagination_objectSpread({}, filters, {
            page: page
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
        justify: "center",
        py: 8,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paginator_esm/* default */.Z, {
            current: filters.page,
            responsive: {
                activePage: true
            },
            itemRender: itemRender,
            pageNeighbours: 2,
            pageSize: 10,
            paginationProps: {
                display: 'flex'
            },
            total: total,
            onChange: handleOnChange,
            baseStyles: {
                bg: 'transparent',
                borderColor: 'transparent',
                borderRadius: '50%',
                borderWidth: 1,
                color: 'text.900',
                lineHeight: 8,
                p: 0,
                w: 8
            },
            activeStyles: {
                bg: 'primary.150',
                borderColor: 'primary.500'
            }
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js
var chakra_ui_icons_esm = __webpack_require__(69070);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__(89714);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/sub/index.js
var sub = __webpack_require__(77239);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(80241);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(75657);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 1 modules
var useCookies = __webpack_require__(15579);
// EXTERNAL MODULE: ./public/icons/jobs/PurpleFaBriefcase.svg
var PurpleFaBriefcase = __webpack_require__(1723);
// EXTERNAL MODULE: ./public/icons/jobs/PurpleFaDollarSign.svg
var PurpleFaDollarSign = __webpack_require__(82161);
// EXTERNAL MODULE: ./src/components/atoms/badge/index.tsx + 3 modules
var badge = __webpack_require__(90748);
// EXTERNAL MODULE: ./src/components/atoms/badgeTech/index.tsx
var badgeTech = __webpack_require__(70579);
// EXTERNAL MODULE: ./src/components/atoms/countryFlag/index.tsx
var countryFlag = __webpack_require__(44085);
// EXTERNAL MODULE: ./src/components/atoms/sanitize/index.tsx
var sanitize = __webpack_require__(68335);
// EXTERNAL MODULE: ./src/components/atoms/textTag/index.tsx
var textTag = __webpack_require__(32112);
// EXTERNAL MODULE: ./src/lib/constants/auth.ts
var auth = __webpack_require__(70333);
// EXTERNAL MODULE: ./src/lib/constants/cookies.ts
var constants_cookies = __webpack_require__(12062);
// EXTERNAL MODULE: ./src/lib/constants/paths.ts
var paths = __webpack_require__(29770);
// EXTERNAL MODULE: ./src/lib/utils/formatCity/index.tsx
var formatCity = __webpack_require__(19266);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/intervalToDuration/index.js
var intervalToDuration = __webpack_require__(26703);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatDuration/index.js
var formatDuration = __webpack_require__(44907);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/pt-BR/index.js + 5 modules
var pt_BR = __webpack_require__(52488);
;// CONCATENATED MODULE: ./src/lib/utils/getJobCustomTimeDuration/index.ts


/**
 * Returns a string in portuguese containing the difference of creation date and current date, prioritizing weeks and then days.
 * If more than four weeks ou less than a day, returns a fixed string
 * Example: Há 2 dias
 * Example: Há 3 semanas
 * Example: Há mais de um mês
 * Example: Há menos de um dia
 *
 * @param startDate {string | Date}
 * @param endDate {string | Date}
 *
 * @returns {string}
 */ var getJobCustomTimeDurationString = function(startDate, endDate) {
    var duration = (0,intervalToDuration/* default */.Z)({
        start: new Date(startDate),
        end: new Date(endDate)
    });
    if (duration.months || duration.years) return 'H\xe1 mais de um m\xeas';
    if (!duration.days) return 'H\xe1 menos de um dia';
    var format = [
        'days'
    ];
    // Add weeks
    if (duration.days && !duration.weeks) {
        duration.weeks = Math.floor(duration.days / 7);
        duration.days -= duration.weeks * 7;
    }
    if (duration.weeks) format = [
        'weeks'
    ];
    var formatOptions = {
        format: format,
        locale: pt_BR/* default */.Z
    };
    return "H\xe1 ".concat((0,formatDuration/* default */.Z)(duration, formatOptions));
};

// EXTERNAL MODULE: ./src/lib/utils/jobCard/index.ts
var jobCard = __webpack_require__(28611);
;// CONCATENATED MODULE: ./src/components/molecules/jobs/showcaseCard/index.tsx

/* eslint-disable no-nested-ternary */ 
























function showcaseCard_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function showcaseCard_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function showcaseCard_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function showcaseCard_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function showcaseCard_slicedToArray(arr, i) {
    return showcaseCard_arrayWithHoles(arr) || showcaseCard_iterableToArrayLimit(arr, i) || showcaseCard_unsupportedIterableToArray(arr, i) || showcaseCard_nonIterableRest();
}
function showcaseCard_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return showcaseCard_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return showcaseCard_arrayLikeToArray(o, minLen);
}
var ShowcaseCard = function(param) {
    var jobId = param.jobId, focus = param.focus, slug = param.slug, createdAt = param.createdAt, title = param.title, techs = param.techs, city = param.city, acceptRemote = param.acceptRemote, cltSalaryMin = param.cltSalaryMin, cltSalaryMax = param.cltSalaryMax, pjSalaryMin = param.pjSalaryMin, pjSalaryMax = param.pjSalaryMax, usdAnnualSalaryMin = param.usdAnnualSalaryMin, usdAnnualSalaryMax = param.usdAnnualSalaryMax, experienceLevel = param.experienceLevel, requirements = param.requirements, description = param.description, hideSalary = param.hideSalary, isJobInternational = param.isJobInternational, hybrid = param.hybrid, jobType = param.jobType, companySlug = param.companySlug;
    var ref3;
    var ref1 = showcaseCard_slicedToArray((0,useCookies/* default */.Z)([
        auth/* AUTH_TOKEN */.UA,
        constants_cookies/* USER_TYPE */.$A
    ]), 1), cookies = ref1[0];
    var candidateAuth = !!cookies.auth_token && !!cookies.user_type && cookies.user_type === 'candidate';
    var ref2 = (0,react.useState)(false), hasInterest = ref2[0], setHasInterest = ref2[1];
    var loading = (0,graphql/* useGetCurrentCandidateInterestJobsByJobIdsQuery */.q3r)({
        variables: {
            jobs: parseInt(jobId, 10)
        },
        skip: !candidateAuth,
        onCompleted: function(data) {
            var ref;
            setHasInterest(data !== undefined && (data === null || data === void 0 ? void 0 : (ref = data.getCurrentCandidateInterestJobsByJobIds) === null || ref === void 0 ? void 0 : ref.length) > 0);
        }
    }).loading;
    var isNew = (0,isAfter/* default */.Z)(new Date(createdAt), (0,sub/* default */.Z)(new Date(), {
        days: 5
    }));
    var createdSince = getJobCustomTimeDurationString(createdAt, new Date());
    var jobPath = jobType === graphql/* JobTypeEnum.FullSupport */.a_7.FullSupport ? paths/* SLUG_JOB */.M2(slug) : jobType === graphql/* JobTypeEnum.Ats */.a_7.Ats ? paths/* ATS_SLUG_JOB */.EU(companySlug, slug) : paths/* V2_SLUG_JOB */.ZG(companySlug, slug);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: jobPath,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            target: "_blank",
            href: jobPath,
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                _hover: {
                    boxShadow: 'sm'
                },
                py: 30,
                px: [
                    2,
                    7
                ],
                backgroundColor: "white.100",
                cursor: "pointer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                        justifyContent: "space-between",
                        mb: 5,
                        children: [
                            focus ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 600,
                                color: "primary.500",
                                fontSize: "xs",
                                children: focus
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {}),
                            isNew ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                fontWeight: 700,
                                color: "primary.500",
                                fontSize: "xs",
                                children: "NOVA"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                fontWeight: 400,
                                color: "grey.900",
                                fontSize: "xs",
                                children: createdSince
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                        flexDir: "row",
                        justify: "flex-start",
                        align: "flex-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* default */.Z, {
                            format: "h3",
                            fontWeight: 400,
                            fontSize: "2xl",
                            lineHeight: 9,
                            letterSpacing: "tight",
                            color: "black.700",
                            mb: 22,
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                        color: "text.100",
                        align: "center",
                        flexWrap: "wrap",
                        mb: 5,
                        children: [
                            (0,jobCard/* formatTechs */.W)(techs).map(function(tech) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/vagas-:tech",
                                    as: tech.urlPath,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badgeTech/* BadgeTech */.T, {
                                        text: tech.name,
                                        borderColor: "primary.500",
                                        hoverBgColor: "primary.500",
                                        hoverTextColor: "white.100",
                                        textColor: "primary.500",
                                        mr: 3.5,
                                        mb: 2
                                    })
                                }, tech.name);
                            }),
                            !loading && candidateAuth && hasInterest && /*#__PURE__*/ (0,jsx_runtime.jsx)(textTag/* TextTag */.r, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* CheckCircleIcon */.rE, {}),
                                text: "J\xe1 demonstrou interesse",
                                textColor: "primary.50",
                                backgroundColor: "green.950",
                                mb: 2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                        flexDirection: [
                            'column',
                            'row'
                        ],
                        align: "center",
                        alignItems: "flex-start",
                        mb: 4,
                        children: [
                            (city || acceptRemote) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Grid */.rj, {
                                mb: [
                                    4,
                                    0
                                ],
                                gap: 2.5,
                                templateColumns: "auto auto auto",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                        pt: "2px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(countryFlag/* CountryFlag */.A, {
                                            flag: isJobInternational ? countryFlag/* FlagEnum.usFlag */.$.usFlag : countryFlag/* FlagEnum.brFlag */.$.brFlag,
                                            height: 20
                                        })
                                    }),
                                    city && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                            fontSize: "sm",
                                            color: "black.700",
                                            children: (0,formatCity/* formatCity */.H)(city)
                                        })
                                    }),
                                    !isJobInternational && (acceptRemote || hybrid) && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* Badge */.C, {
                                        variant: "remote",
                                        text: hybrid ? 'h\xedbrido' : 'remoto'
                                    }),
                                    isJobInternational && acceptRemote && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* Badge */.C, {
                                        variant: "remote",
                                        text: city ? 'h\xedbrido' : 'remoto'
                                    })
                                ]
                            }),
                            jobExperienceLevel/* jobExperienceLevelMap */.nd[experienceLevel] && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                                ml: [
                                    0,
                                    12
                                ],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: PurpleFaBriefcase/* default */.Z,
                                        alt: "Briefcase icon",
                                        height: "20px",
                                        width: "20px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                        ml: 2.5,
                                        fontSize: "sm",
                                        color: "black.700",
                                        children: ((ref3 = jobExperienceLevel/* jobExperienceLevelMap */.nd[experienceLevel]) === null || ref3 === void 0 ? void 0 : ref3.seniority) || 'N\xe3o informada'
                                    })
                                ]
                            })
                        ]
                    }),
                    !hideSalary && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            (cltSalaryMin > 0 || cltSalaryMax > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Grid */.rj, {
                                justifyContent: "start",
                                mb: 1,
                                alignItems: "center",
                                templateColumns: "repeat(3, auto)",
                                columnGap: 2.5,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                        pt: "6px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            src: PurpleFaDollarSign/* default */.Z,
                                            alt: "Dollar sign icon",
                                            height: "20px",
                                            width: "20px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(salaryRange/* SalaryRange */.m, {
                                            minSalary: cltSalaryMin,
                                            maxSalary: cltSalaryMax,
                                            currency: "R$",
                                            suffix: salaryRange/* SalarySuffixTypes.CLT */.l.CLT
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* Badge */.C, {
                                            text: "CLT"
                                        })
                                    })
                                ]
                            }),
                            (pjSalaryMin > 0 || pjSalaryMax > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Grid */.rj, {
                                justifyContent: "start",
                                mb: 4,
                                templateColumns: "repeat(3, auto)",
                                columnGap: 2.5,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                        pt: "2px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            src: PurpleFaDollarSign/* default */.Z,
                                            alt: "Dollar sign icon",
                                            height: "20px",
                                            width: "20px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                        gridColumnStart: [
                                            2,
                                            2
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(salaryRange/* SalaryRange */.m, {
                                            minSalary: pjSalaryMin,
                                            maxSalary: pjSalaryMax,
                                            currency: "R$",
                                            suffix: salaryRange/* SalarySuffixTypes.PJ */.l.PJ
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* Badge */.C, {
                                            variant: "rawText",
                                            text: "PJ ou Cooperativa"
                                        })
                                    })
                                ]
                            }),
                            (usdAnnualSalaryMin > 0 || usdAnnualSalaryMax > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Grid */.rj, {
                                justifyContent: "start",
                                mb: 4,
                                templateColumns: "repeat(3, auto)",
                                columnGap: 2.5,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                        pt: "2px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            src: PurpleFaDollarSign/* default */.Z,
                                            alt: "Dollar sign icon",
                                            height: "20px",
                                            width: "20px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                        gridColumnStart: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(salaryRange/* SalaryRange */.m, {
                                            minSalary: usdAnnualSalaryMin,
                                            maxSalary: usdAnnualSalaryMax,
                                            currency: "US$",
                                            suffix: salaryRange/* SalarySuffixTypes.PJ_US */.l.PJ_US
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* Badge */.C, {
                                            variant: "rawText",
                                            text: "PJ ou Cooperativa"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !!requirements && /*#__PURE__*/ (0,jsx_runtime.jsx)(sanitize/* SanitizeHTML */.h, {
                        mb: 4,
                        fontSize: "sm",
                        color: "black.700",
                        lineHeight: 6,
                        html: "".concat(requirements.substring(0, 300), " ").concat(requirements.length > 300 ? '...' : '')
                    }),
                    !!description && /*#__PURE__*/ (0,jsx_runtime.jsx)(sanitize/* SanitizeHTML */.h, {
                        mb: 4,
                        fontSize: "sm",
                        color: "black.700",
                        lineHeight: 6,
                        html: "".concat(description.substring(0, 300), " ").concat(description.length > 300 ? '...' : '')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                        justifyContent: "right",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_media_query_esm/* Hide */.c, {
                            below: "sm",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: jobPath,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                    ml: 4,
                                    p: "16px 30px",
                                    children: "Ver detalhes"
                                })
                            })
                        })
                    })
                ]
            })
        })
    }));
};

// EXTERNAL MODULE: ./src/components/molecules/showInterestButton/unauthenticated/index.tsx
var unauthenticated = __webpack_require__(96333);
// EXTERNAL MODULE: ./src/components/molecules/form/select/index.tsx + 10 modules
var form_select = __webpack_require__(92516);
;// CONCATENATED MODULE: ./src/components/molecules/jobs/emptyList/index.tsx

/* eslint-disable no-nested-ternary */ 



var EmptyList = function(param) {
    var isCandidateAuthenticated = param.isCandidateAuthenticated;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
        mt: 90,
        spacing: 5,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                textAlign: "center",
                fontSize: [
                    'xl',
                    'xl',
                    '3xl'
                ],
                maxWidth: [
                    270,
                    270,
                    400
                ],
                children: "N\xe3o encontramos vagas para a sua busca 😕"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                textAlign: "center",
                fontSize: "sm",
                maxWidth: [
                    280,
                    280,
                    450
                ],
                children: isCandidateAuthenticated ? 'Tente uma nova uma busca para encontrar mais oportunidades.' : 'Tente uma nova uma busca para encontrar mais oportunidades. Aproveite para criar o seu perfil e fique por dentro das dezenas de novas oportunidades que, todos os dias, surgem por aqui.'
            }),
            !isCandidateAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: paths/* CANDIDATE_LP */.Is,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                    mt: 30,
                    children: "Criar meu perfil"
                })
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/jobs/showcase/index.tsx










function showcase_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function showcase_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            showcase_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ShowcaseJobsList = function(param) {
    var handleSearchJobs = param.handleSearchJobs, jobs = param.jobs, loading = param.loading, _total = param.total, total = _total === void 0 ? 0 : _total, isCandidateAuthenticated = param.isCandidateAuthenticated;
    var ref2 = (0,jobsShowcaseFilters/* useJobFilters */.VP)(), filters = ref2.filters, setOrder = ref2.setOrder;
    var handleOrderOnChange = function(order) {
        setOrder(order);
        handleSearchJobs(showcase_objectSpread({}, filters, {
            order: order
        }));
    };
    var _technologies;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
        as: "section",
        children: [
            jobs && jobs.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                as: "header",
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                        fontSize: 16,
                        fontWeight: 400,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                                as: "span",
                                color: "primary.500",
                                fontWeight: 700,
                                pr: 1,
                                children: [
                                    total,
                                    " vagas"
                                ]
                            }),
                            "dispon\xedveis"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        display: {
                            base: 'none',
                            md: 'block'
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_select/* default */.Z, {
                            id: "order",
                            name: "order",
                            isSearchable: false,
                            options: orderOptions,
                            value: filters.order,
                            placeholder: "Selecione uma op\xe7\xe3o",
                            onChange: function(o) {
                                return handleOrderOnChange(o.target.value);
                            },
                            variant: "outline",
                            selectedOptionStyle: "check",
                            chakraStyles: {
                                container: function(provided) {
                                    return showcase_objectSpread({}, provided, {
                                        w: 40
                                    });
                                },
                                control: function(provided) {
                                    return showcase_objectSpread({}, provided, {
                                        bgColor: 'primary.150',
                                        borderColor: 'primary.500',
                                        borderRadius: 20,
                                        cursor: 'pointer',
                                        fontSize: 14,
                                        fontWeight: 600,
                                        color: 'primary.500',
                                        _hover: {
                                            borderColor: 'primary.500'
                                        },
                                        _focus: {
                                            borderColor: 'primary.500'
                                        }
                                    });
                                },
                                option: function(provided, state) {
                                    return showcase_objectSpread({}, provided, {
                                        bgColor: 'white',
                                        color: state.isSelected ? 'primary.500' : 'text.900',
                                        fontSize: 14,
                                        fontWeight: state.isSelected ? 700 : 400,
                                        _hover: {
                                            bgColor: 'primary.150'
                                        }
                                    });
                                },
                                placeholder: function(provided) {
                                    return showcase_objectSpread({}, provided, {
                                        color: 'primary.500'
                                    });
                                },
                                dropdownIndicator: function(provided) {
                                    return showcase_objectSpread({}, provided, {
                                        padding: 2,
                                        bgColor: 'transparent',
                                        color: 'primary.500'
                                    });
                                }
                            }
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                columns: 1,
                spacing: 6,
                pt: 5,
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, {
                    p: 8,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_spinner_esm/* Spinner */.$, {
                        color: "primary.500"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        jobs && (jobs === null || jobs === void 0 ? void 0 : jobs.length) > 0 ? jobs === null || jobs === void 0 ? void 0 : jobs.map(function(job, index) {
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowcaseCard, {
                                        jobId: job.id,
                                        focus: (ref = job.focus) === null || ref === void 0 ? void 0 : ref.description,
                                        acceptRemote: job.remoteWork,
                                        city: (ref1 = job.city) === null || ref1 === void 0 ? void 0 : ref1.name,
                                        slug: job.slug,
                                        techs: (_technologies = job.technologies) !== null && _technologies !== void 0 ? _technologies : [],
                                        title: job.title,
                                        cltSalaryMin: job.cltMinSalary,
                                        cltSalaryMax: job.cltMaxSalary,
                                        pjSalaryMin: job.pjMinSalary,
                                        pjSalaryMax: job.pjMaxSalary,
                                        usdAnnualSalaryMin: job.usdAnnualSalaryMin,
                                        usdAnnualSalaryMax: job.usdAnnualSalaryMax,
                                        createdAt: job.createdAt,
                                        experienceLevel: job.experienceLevel,
                                        requirements: job.requirements,
                                        description: job.description,
                                        hideSalary: job.hideSalary,
                                        isJobInternational: job.isInternational,
                                        hybrid: job.hybrid,
                                        jobType: job.jobType,
                                        companySlug: job.company.slug
                                    }, job.id),
                                    !isCandidateAuthenticated && index === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                                        alignItems: "center",
                                        bg: "primary.150",
                                        flexDir: {
                                            base: 'column',
                                            lg: 'row'
                                        },
                                        p: 8,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* default */.Z, {
                                                color: "primary.500",
                                                fontWeight: 700,
                                                format: "h3",
                                                m: 0,
                                                p: 0,
                                                fontSize: "2xl",
                                                letterSpacing: 0,
                                                textAlign: [
                                                    'center',
                                                    'center',
                                                    'center',
                                                    'left'
                                                ],
                                                children: "Crie seu perfil e receba diversas propostas de emprego! 🚀"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(unauthenticated/* UnauthenticatedShowInterestButton */.A, {
                                                ml: {
                                                    base: 0,
                                                    lg: 4
                                                },
                                                mt: {
                                                    base: 4,
                                                    lg: 0
                                                },
                                                size: "xl",
                                                w: {
                                                    base: 'full',
                                                    lg: 'auto'
                                                },
                                                whiteSpace: {
                                                    base: 'break-spaces',
                                                    lg: 'nowrap'
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }, job.id);
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyList, {
                            isCandidateAuthenticated: isCandidateAuthenticated
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination, {
                            total: total,
                            handleSearchJobs: handleSearchJobs
                        })
                    ]
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/organisms/landingPageHeader/index.tsx + 1 modules
var landingPageHeader = __webpack_require__(28147);
// EXTERNAL MODULE: ./src/lib/constants/header.ts
var header = __webpack_require__(71458);
// EXTERNAL MODULE: ./src/lib/hooks/useSession.ts
var useSession = __webpack_require__(19713);
// EXTERNAL MODULE: ./src/lib/repositories/candidate.repository.ts
var candidate_repository = __webpack_require__(97635);
// EXTERNAL MODULE: ./src/lib/repositories/searchCandidateFilters.repository.ts
var searchCandidateFilters_repository = __webpack_require__(17132);
;// CONCATENATED MODULE: ./src/components/templates/jobs/showcase/index.tsx


/* eslint-disable react-hooks/exhaustive-deps */ 
















function showcase_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function showcase_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function jobs_showcase_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function showcase_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function showcase_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function jobs_showcase_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            jobs_showcase_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function showcase_slicedToArray(arr, i) {
    return showcase_arrayWithHoles(arr) || showcase_iterableToArrayLimit(arr, i) || showcase_unsupportedIterableToArray(arr, i) || showcase_nonIterableRest();
}
function showcase_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return showcase_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return showcase_arrayLikeToArray(o, minLen);
}
// const SeniorityFilterMap = (seniority: SeniorityEnum[]) => {
//   return jobExperienceLevelOptions.filter((option) => seniority.includes(option.value));
// }
var ShowcasePageTemplate = function() {
    var router = (0,next_router.useRouter)();
    var ref9 = (0,react.useState)([
        salaryDefaults.min,
        salaryDefaults.max
    ]), defaultSalaryValues = ref9[0], setDefaultSalaryValues = ref9[1];
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(), jobs = ref2[0], setJobs = ref2[1];
    var ref3 = (0,react.useState)(0), totalJobs = ref3[0], setTotalJobs = ref3[1];
    var currentToken = (0,useSession/* default */.Z)().currentToken;
    var ref4 = showcase_slicedToArray((0,graphql/* useSearchTechsLazyQuery */.q5Q)(), 1), getTechs = ref4[0];
    var ref5 = showcase_slicedToArray((0,graphql/* useFindShowcaseJobsLazyQuery */.iNG)(), 1), findShowcaseJobs = ref5[0];
    var ref6 = (0,graphql/* useFindMaxMinJobsSalaryQuery */.K95)({
        onCompleted: function(data) {
            var ref, ref8;
            setDefaultSalaryValues([
                ((ref = data.findMaxMinJobsSalary) === null || ref === void 0 ? void 0 : ref.minSalary) || salaryDefaults.min,
                ((ref8 = data.findMaxMinJobsSalary) === null || ref8 === void 0 ? void 0 : ref8.maxSalary) || salaryDefaults.max, 
            ]);
        }
    }), minMaxSalaryLoading = ref6.loading;
    var ref7 = (0,jobsShowcaseFilters/* useJobFilters */.VP)(), filters = ref7.filters, setTechs = ref7.setTechs;
    (0,graphql/* useGetCandidateProfileDataQuery */.vqJ)({
        skip: !currentToken,
        onCompleted: function(data) {
            (0,candidate_repository/* setCandidate */.Aw)(data === null || data === void 0 ? void 0 : data.getCandidateProfileData.candidate);
        }
    });
    var handleSearchJobs = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(updatedFilters) {
            var ref, ref10, ref11, ref12, applyFilters, showcaseParams, ref13, data, loading;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setIsLoading(true);
                        setTotalJobs(0);
                        setJobs([]);
                        applyFilters = updatedFilters ? jobs_showcase_objectSpread({}, updatedFilters) : jobs_showcase_objectSpread({}, filters);
                        showcaseParams = {
                            companyLocation: applyFilters.companyLocation,
                            order: applyFilters.order,
                            remoteWork: (applyFilters === null || applyFilters === void 0 ? void 0 : (ref = applyFilters.type) === null || ref === void 0 ? void 0 : ref.includes('remote')) || false,
                            pagination: {
                                page: ((applyFilters === null || applyFilters === void 0 ? void 0 : applyFilters.page) || 1) - 1,
                                perPage: 10
                            }
                        };
                        if (!!applyFilters.minSalary && !!applyFilters.maxSalary) showcaseParams.salaryRange = {
                            min: applyFilters.minSalary || searchCandidateFilters_repository/* SALARY_DEFAULT_MIN */.pg,
                            max: applyFilters.maxSalary || searchCandidateFilters_repository/* SALARY_DEFAULT_MAX */.N7
                        };
                        if (applyFilters.city) showcaseParams.cities = [
                            applyFilters.city.value.toString()
                        ];
                        if (applyFilters.workMode) showcaseParams.workMode = applyFilters.workMode;
                        if (applyFilters.seniority) showcaseParams.seniority = applyFilters.seniority;
                        if (applyFilters.techs) showcaseParams.technologies = applyFilters === null || applyFilters === void 0 ? void 0 : (ref10 = applyFilters.techs) === null || ref10 === void 0 ? void 0 : ref10.map(function(tech) {
                            return tech.value.toString();
                        });
                        if (applyFilters.focuses) showcaseParams.focuses = applyFilters.focuses.map(function(focus) {
                            return focus.id;
                        });
                        if (applyFilters.companyLocation) showcaseParams.companyLocation = applyFilters.companyLocation;
                        _ctx.next = 15;
                        return findShowcaseJobs({
                            variables: {
                                showcaseParams: showcaseParams
                            }
                        });
                    case 15:
                        ref13 = _ctx.sent;
                        data = ref13.data;
                        loading = ref13.loading;
                        setJobs((data === null || data === void 0 ? void 0 : (ref11 = data.findShowcaseJobs) === null || ref11 === void 0 ? void 0 : ref11.data) || []);
                        setTotalJobs((data === null || data === void 0 ? void 0 : (ref12 = data.findShowcaseJobs) === null || ref12 === void 0 ? void 0 : ref12.total) || 0);
                        setIsLoading(loading);
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSearchJobs(updatedFilters) {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * Get jobs on first page load if the url has a tech param
   */ (0,react.useEffect)(function() {
        var techQuery = router.query.tech;
        if (!techQuery) {
            handleSearchJobs();
            return;
        }
        setIsLoading(true);
        var techFilter = [];
        getTechs({
            variables: {
                textSearch: techQuery
            }
        }).then(function(response) {
            var ref;
            if (response.data && ((ref = response.data) === null || ref === void 0 ? void 0 : ref.searchTechs.length) > 0) {
                techFilter.push({
                    text: response.data.searchTechs[0].name,
                    value: response.data.searchTechs[0].id
                });
                setTechs(techFilter);
            }
        }).finally(function() {
            handleSearchJobs(jobs_showcase_objectSpread({}, filters, {
                techs: techFilter
            }));
        });
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(landingPageHeader/* default */.Z, {
                headerLinks: header/* headerLinks.filter */.Gb.filter(function(link) {
                    return link.path === paths/* JOBS */.WN;
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                bgColor: "white.200",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
                    maxW: "container.xxl",
                    pb: 8,
                    pt: 16,
                    px: [
                        2.5,
                        4
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(heading/* default */.Z, {
                            color: "text.900",
                            fontWeight: 400,
                            format: "h2",
                            my: [
                                10,
                                20
                            ],
                            textAlign: [
                                'start',
                                'center'
                            ],
                            children: [
                                "As melhores vagas em ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "empresas de tecnologia 🚀"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                            templateColumns: [
                                '100%',
                                '100%',
                                '60% 40%',
                                '70% 30%'
                            ],
                            gap: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_media_query_esm/* Hide */.c, {
                                    above: "md",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilters, {
                                        showOrderFilter: jobs !== undefined && (jobs === null || jobs === void 0 ? void 0 : jobs.length) > 0,
                                        defaultSalaryValues: defaultSalaryValues,
                                        handleSearchJobs: handleSearchJobs
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowcaseJobsList, {
                                    isCandidateAuthenticated: !!currentToken,
                                    handleSearchJobs: handleSearchJobs,
                                    jobs: jobs || [],
                                    loading: isLoading,
                                    total: totalJobs
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_media_query_esm/* Hide */.c, {
                                    below: "md",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_skeleton_esm/* Skeleton */.Od, {
                                        isLoaded: !minMaxSalaryLoading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopFilters, {
                                            defaultSalaryValues: defaultSalaryValues,
                                            handleSearchJobs: handleSearchJobs
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* Footer */.$, {})
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/atoms/themeProvider/index.tsx + 2 modules
var themeProvider = __webpack_require__(92015);
;// CONCATENATED MODULE: ./src/pages/vagas/index.page.tsx






var Jobs = function() {
    var router = (0,next_router.useRouter)();
    var techQuery = router.query.tech;
    var techName = techQuery && techQuery.charAt(0).toUpperCase().concat(techQuery.replace('-', ' ').slice(1));
    var title = techQuery ? "Vagas ".concat(techName, " | +300 Vagas para DEVs") : 'Geekhunter: Recrute Talentos tech | Vagas para profissionais tech';
    var description = techQuery ? "Encontre Vagas de ".concat(techName, " para v\xe1rias cidades e senioridades. Crie um perfil na plataforma GeekHunter. Ver vagas agora!") : 'GeekHunter \xe9 uma plataforma especialista no match de profissionais de tecnologia e empresas. Encontre vagas para profissionais tech. Veja!';
    var monolithLink = "https://www.geekhunter.com.br" || 0;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(themeProvider/* ThemeProvider */.f, {
        colors: candidate/* candidateColorScheme */.h,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: title,
                description: description,
                canonical: "".concat(monolithLink).concat(router.pathname).concat(techQuery ? '-' : '').concat(techQuery || '')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowcasePageTemplate, {})
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ var index_page = (Jobs);


/***/ }),

/***/ 75347:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 34017:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 59905:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,4617,6556,9866,1190,9161,8319,5966,6707,9914,6936,8596,401,5613,1274,962,7121,2661,9826,2516,1930,9774,2888,179], function() { return __webpack_exec__(70008); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);